(function () {
  const UPLOAD_IMAGE_MAX_DIMENSION = 1600;
  const UPLOAD_IMAGE_OUTPUT_QUALITY = 0.82;
  const UPLOAD_IMAGE_PASSTHROUGH_BYTES = 900 * 1024;
  const GENERATED_IMAGE_TARGET_WIDTH = 1080;
  const GENERATED_IMAGE_TARGET_HEIGHT = 1440;
  const GENERATED_IMAGE_OUTPUT_QUALITY = 0.9;
  const HISTORY_THUMB_MAX_DIMENSION = 480;
  const HISTORY_THUMB_OUTPUT_QUALITY = 0.78;
  const HISTORY_SKELETON_CARD_COUNT = 5;
  const IMAGE_DELIVERY_ORIGIN = 'https://images.deblancas.com';
  const SHOPIFY_ASSET_ORIGIN = 'https://cdn.shopify.com';
  const SHOPIFY_VIDEO_ORIGIN = 'https://video.shopifycdn.com';
  const HISTORY_PROGRESS_MIN_VISIBLE_MS = 320;
  const HISTORY_PROGRESS_INITIAL_PHASE_MS = 520;
  const HISTORY_PROGRESS_CRUISE_PHASE_MS = 2600;
  const HISTORY_PROGRESS_FULL_TARGET = 0.88;
  const HISTORY_PROGRESS_INITIAL_TARGET = 0.42;
  const HISTORY_PROGRESS_LIGHT_TARGET = 0.74;
  const OPENING_INTRO_TOTAL_MS = 6500;
  const OPENING_INTRO_HIDE_MS = 6000;
  const OPENING_INTRO_REPLAY_GUARD_MS = 6400;
  const OPENING_INTRO_COLUMNS_DESKTOP = [
    { delay: '0.00s', duration: '4.00s', start: '-72vh', end: '-18vh' },
    { delay: '0.08s', duration: '4.00s', start: '-84vh', end: '-16vh' },
    { delay: '0.16s', duration: '4.00s', start: '-68vh', end: '-22vh' },
    { delay: '0.24s', duration: '4.00s', start: '-80vh', end: '-18vh' },
    { delay: '0.32s', duration: '4.00s', start: '-70vh', end: '-20vh' },
  ];
  const OPENING_INTRO_COLUMNS_MOBILE = [
    { delay: '0.00s', duration: '4.00s', start: '-70vh', end: '-20vh' },
    { delay: '0.10s', duration: '4.00s', start: '-82vh', end: '-18vh' },
    { delay: '0.20s', duration: '4.00s', start: '-74vh', end: '-22vh' },
  ];
  const OPENING_INTRO_CARD_VARIANTS = [
    { rotate: '0deg', shift: '-4px', scale: '0.98' },
    { rotate: '0deg', shift: '4px', scale: '1.02' },
    { rotate: '0deg', shift: '0px', scale: '1.00' },
    { rotate: '0deg', shift: '-2px', scale: '1.04' },
    { rotate: '0deg', shift: '2px', scale: '0.96' },
    { rotate: '0deg', shift: '0px', scale: '1.01' },
  ];
  const GUEST_SAMPLE_PRESETS = [
    { label: 'Pendant / Akoya / Gold', range: '$1,200 - $2,400' },
    { label: 'Earrings / Freshwater / Gold', range: '$900 - $1,800' },
    { label: 'Ring / South Sea / 18K Gold', range: '$2,400 - $4,600' },
  ];
  const sections = document.querySelectorAll('[data-pearl-designer]');
  if (!sections.length) {
    return;
  }

  ensureImageDeliveryConnectionHints(IMAGE_DELIVERY_ORIGIN);
  ensureImageDeliveryConnectionHints(SHOPIFY_ASSET_ORIGIN);
  ensureImageDeliveryConnectionHints(SHOPIFY_VIDEO_ORIGIN);
  primeOpeningIntroAssets();

  if (!window.__pearlDesignerIntroInitialized) {
    window.__pearlDesignerIntroInitialized = true;
    playOpeningIntro();
    window.addEventListener('pageshow', (event) => {
      if (!event.persisted) {
        return;
      }
      playOpeningIntro();
    });
  }

  sections.forEach((section) => {
    if (section.dataset.pearlDesignerReady === 'true') {
      return;
    }

    section.dataset.pearlDesignerReady = 'true';

    const endpoint = section.dataset.apiEndpoint || '/apps/ai-pearl-designer';
    const currency = section.dataset.currency || 'USD';
    const customerEmail = section.dataset.customerEmail || '';
    const customerName = section.dataset.customerName || '';
    const customerId = section.dataset.customerId || '';
    const customerOrderCount = Number(section.dataset.customerOrderCount || 0);
    const shopDomain = section.dataset.shopDomain || '';
    const loginUrl = section.dataset.loginUrl || '/account/login';
    const guestSubmitLabel =
      String(section.dataset.guestSubmitLabel || '').trim() || 'Generate Complimentary Concept';
    const turnstileSiteKey = section.dataset.turnstileSiteKey || '';
    const isLoggedInCustomer = Boolean(customerId);
    const visitorId = getVisitorId(shopDomain);
    const guestSessionId = isLoggedInCustomer
      ? getStoredGuestSessionId(shopDomain)
      : getGuestSessionId(shopDomain);
    const influencerTracking = getInfluencerTrackingContext();
    const hasUsedGuestTrial = isLoggedInCustomer ? false : hasGuestTrialBeenUsed(shopDomain);
    const form = section.querySelector('[data-role="form"]');
    const promptField = section.querySelector('[data-role="prompt"]') || form?.elements?.prompt || null;
    const fileInput = section.querySelector('[data-role="reference-image"]');
    const uploadBox = section.querySelector('.pearl-designer__upload');
    const uploadPreview = section.querySelector('[data-role="upload-preview"]');
    const status = section.querySelector('[data-role="status"]');
    const submitButtons = Array.from(section.querySelectorAll('button[type="submit"]'));
    const button = section.querySelector('[data-role="submit"]') || submitButtons[0] || null;
    const generatedFrame = section.querySelector('[data-role="generated-preview"]');
    const estimateBlock = section.querySelector('[data-role="estimate"]');
    const notesBlock = section.querySelector('[data-role="notes"]');
    const historyMeta = section.querySelector('[data-role="history-meta"]');
    const uploadBadge = section.querySelector('[data-role="upload-badge"]');
    const quotaValue = section.querySelector('[data-role="quota-value"]');
    const quotaMonth = section.querySelector('[data-role="quota-month"]');
    const appointmentGallery = section.querySelector('[data-role="appointment-gallery"]');
    const appointmentSelection = section.querySelector('[data-role="appointment-selection"]');
    const appointmentButton = section.querySelector('[data-role="appointment-button"]');
    const appointmentBrowser = appointmentGallery?.closest('.pearl-designer__appointment-browser') || null;
    const historyDetail = section.querySelector('[data-role="history-detail"]');
    const guestPrimaryCta = section.querySelector('[data-role="guest-primary-cta"]');
    const guestSamplesCta = section.querySelector('[data-role="guest-samples-cta"]');
    const guestSamplesSection = section.querySelector('[data-role="guest-samples"]');
    const guestSamplesGrid = section.querySelector('[data-role="guest-samples-grid"]');
    const guestLoginGate = section.querySelector('[data-role="guest-login-gate"]');
    const guestLoginButtons = Array.from(section.querySelectorAll('[data-role="guest-login-button"]'));
    const guestPromptChips = Array.from(section.querySelectorAll('[data-role="guest-prompt-chip"]'));
    const guestUploadTrigger = section.querySelector('[data-role="guest-upload-trigger"]');
    const guestUploadName = section.querySelector('[data-role="guest-upload-name"]');
    const guestAdvancedToggle = section.querySelector('[data-role="guest-advanced-toggle"]');
    const guestAdvancedOptions = section.querySelector('[data-role="guest-advanced-options"]');
    const guestResultCard = section.querySelector('[data-role="guest-result-card"]');
    const memberUploadTrigger = section.querySelector('[data-role="member-upload-trigger"]');
    const memberUploadName = section.querySelector('[data-role="member-upload-name"]');
    const memberAdvancedToggle = section.querySelector('[data-role="member-advanced-toggle"]');
    const memberAdvancedOptions = section.querySelector('[data-role="member-advanced-options"]');
    const guestJewelryTypeField = section.querySelector('[name="jewelry_type"]');
    const guestVerification = section.querySelector('[data-role="guest-verification"]');
    const guestTurnstile = section.querySelector('[data-role="guest-turnstile"]');
    const appointmentBaseUrl = normalizeAppointmentBaseUrl(
      appointmentButton?.getAttribute('href') || '/pages/appointment-booking'
    );
    const resolvedLoginUrl = buildStorefrontLoginUrl(loginUrl);
    let preparedUpload = null;
    let preparedUploadPromise = null;
    let recentGenerations = [];
    let pendingHistoryItem = null;
    let selectedGenerationId = '';
    let guestTurnstileToken = '';
    let guestTurnstileWidgetId = null;
    let guestPendingSubmitAfterVerification = false;
    let guestGenerationLocked = false;
    let hasReviewedAdvancedControls = false;
    let selectedHistoryRenderToken = 0;
    const preloadedHistoryImageUrls = new Set();
    const historyImagePreloadPromises = new Map();
    const historyCacheKey = buildHistorySessionCacheKey(shopDomain, customerId, customerEmail);
    const historyLoadProgressState = {
      root: null,
      copy: null,
      token: 0,
      startedAt: 0,
      currentProgress: 0,
      rafId: 0,
      timeoutIds: [],
    };

    if (!form) {
      return;
    }

    const statusEndpoint = joinPath(endpoint, 'status');
    const generateEndpoint = joinPath(endpoint, 'generate');
    const historyEndpoint = joinPath(endpoint, 'history');
    const historyImageEndpoint = joinPath(endpoint, 'history/image');
    const historyThumbnailEndpoint = joinPath(endpoint, 'history/thumbnail');
    const normalizeOutputEndpoint = joinPath(endpoint, 'normalize-output');
    const analyticsEndpoint = joinPath(endpoint, 'analytics');
    const attributionEndpoint = joinPath(endpoint, 'attribution');
    const renderingMessages = [
      'Magic is happening',
      'Please stay with us for a moment',
      'The rendering engine is hard at work',
      'Your bespoke concept is taking shape',
    ];
    function setSubmitButtonsDisabled(disabled) {
      submitButtons.forEach((submitButton) => {
        submitButton.disabled = disabled;
      });
    }

    function setSubmitButtonLabels(text) {
      submitButtons.forEach((submitButton) => {
        const label = submitButton.querySelector('.pearl-designer__button-label');
        if (label) {
          label.textContent = text;
        }
      });
    }

    function setGuestResultCardVisible(visible) {
      if (guestResultCard) {
        guestResultCard.hidden = !visible;
      }
    }

    function buildGuestResultSummary(item) {
      return {
        jewelryType: item?.jewelryType || '',
        pearlType: item?.pearlType || '',
        metalMaterial: item?.metalMaterial || '',
        diamondQuality: item?.diamondQuality || '',
      };
    }

    function renderGuestPendingState(item) {
      if (!guestResultCard || !generatedFrame || !estimateBlock || !notesBlock) {
        return;
      }

      setGuestResultCardVisible(true);
      setGeneratedFrameState('rendering');
      generatedFrame.innerHTML = renderingMarkup(renderingMessages);
      estimateBlock.innerHTML = `
        <div class="pearl-designer__estimate-range">
          <span class="pearl-designer__estimate-label">Price Range</span>
          <strong class="pearl-designer__estimate-value">Generating estimate</strong>
        </div>
        <p class="pearl-designer__estimate-copy">Your complimentary guest concept is generating now. The estimate breakdown will appear here automatically when it is ready.</p>
      `;
      notesBlock.innerHTML = renderNotesMarkup(
        'Your guest preview is rendering now. Please stay on this page while we prepare the concept image and styling notes.'
      );
      renderHistoryMeta(buildGuestResultSummary(item));
    }

    function renderGuestFailureState(message, item) {
      if (!guestResultCard || !generatedFrame || !estimateBlock || !notesBlock) {
        return;
      }

      setGuestResultCardVisible(true);
      setGeneratedFrameState('error');
      generatedFrame.innerHTML = placeholderMarkup(
        'Generation failed',
        message || 'Please review the brief and try again.'
      );
      estimateBlock.innerHTML = `
        <div class="pearl-designer__estimate-range">
          <span class="pearl-designer__estimate-label">Price Range</span>
          <strong class="pearl-designer__estimate-value">Estimate unavailable</strong>
        </div>
        <p class="pearl-designer__estimate-copy">We could not prepare the price breakdown for this attempt. Please adjust the brief and try again.</p>
      `;
      notesBlock.innerHTML = renderNotesMarkup(
        'The concept did not finish rendering this time. Update the prompt or reference image and submit again.'
      );
      renderHistoryMeta(buildGuestResultSummary(item));
    }

    setGeneratedFrameState('idle');
    setSubmitButtonsDisabled(true);
    setGuestResultCardVisible(false);
    if (appointmentButton) {
      appointmentButton.setAttribute('href', appointmentBaseUrl);
      appointmentButton.setAttribute('aria-disabled', 'true');
      appointmentButton.setAttribute('target', '_blank');
      appointmentButton.setAttribute('rel', 'noopener noreferrer');
    }
    guestLoginButtons.forEach((loginButton) => {
      loginButton.setAttribute('href', resolvedLoginUrl);
      loginButton.removeAttribute('target');
      loginButton.removeAttribute('rel');
    });
    window.__pearlDesignerAnalyticsEndpoint = analyticsEndpoint;
    window.__pearlDesignerAttributionEndpoint = attributionEndpoint;

    if (influencerTracking.code) {
      persistInfluencerAttribution({
        endpoint: attributionEndpoint,
        tracking: influencerTracking,
        visitorId,
        guestSessionId,
        customerId,
        customerEmail,
        shopDomain,
      });
    }

    if (!isLoggedInCustomer) {
      renderGuestSamples();
      trackDesignerEvent('ai_designer_guest_view', buildGuestAnalyticsProps());
    }

    if (isLoggedInCustomer) {
      bootstrapAuthenticatedCustomer();
    } else if (hasUsedGuestTrial) {
      lockGuestGeneration();
      showGuestLoginGate();
      setStatus(
        status,
        'Your complimentary guest concept has already been used. Sign in to continue generating.',
        'error'
      );
    } else {
      setSubmitButtonLabels(guestSubmitLabel);
      setSubmitButtonsDisabled(false);
      setStatus(status, '', '');
    }

    guestPrimaryCta?.addEventListener('click', () => {
      trackDesignerEvent('ai_designer_guest_primary_cta_click', buildGuestAnalyticsProps());
      scrollToDesignerForm();
    });

    guestSamplesCta?.addEventListener('click', () => {
      trackDesignerEvent('ai_designer_guest_samples_view', buildGuestAnalyticsProps());
      if (guestSamplesSection && !guestSamplesSection.hidden) {
        guestSamplesSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
      scrollToDesignerForm();
    });

    guestLoginButtons.forEach((loginButton) => {
      loginButton.addEventListener('click', (event) => {
        trackDesignerEvent(
          'ai_designer_guest_post_result_login_click',
          buildGuestAnalyticsProps(null, {
            login_intent: String(loginButton.dataset.loginIntent || 'continue'),
          })
        );

        if (
          event.defaultPrevented ||
          event.button !== 0 ||
          event.metaKey ||
          event.ctrlKey ||
          event.shiftKey ||
          event.altKey
        ) {
          return;
        }

        event.preventDefault();
        redirectToLogin();
      });
    });

    guestPromptChips.forEach((chip) => {
      chip.addEventListener('click', () => {
        if (!promptField) {
          return;
        }

        const prompt = String(chip.dataset.prompt || '').trim();
        if (!prompt) {
          return;
        }

        promptField.value = prompt;
        promptField.dispatchEvent(new Event('input', { bubbles: true }));
        const jewelryType = String(chip.dataset.jewelryType || '').trim();
        if (guestJewelryTypeField && jewelryType) {
          guestJewelryTypeField.value = jewelryType;
          guestJewelryTypeField.dispatchEvent(new Event('change', { bubbles: true }));
        }
        promptField.focus({ preventScroll: false });
        if (typeof promptField.setSelectionRange === 'function') {
          promptField.setSelectionRange(prompt.length, prompt.length);
        }

        trackDesignerEvent(
          'ai_designer_guest_prompt_chip_click',
          buildGuestAnalyticsProps(null, {
            chip_label: String(chip.dataset.chipLabel || chip.textContent || '').trim(),
          })
        );
      });
    });

    appointmentGallery?.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-role="history-select"]');
      if (!trigger) {
        return;
      }

      selectedGenerationId = String(trigger.dataset.generationId || '');
      renderHistoryGallery(recentGenerations);
    });

    appointmentButton?.addEventListener('click', (event) => {
      const selectedItem = getSelectedGeneration();
      if (!selectedItem) {
        event.preventDefault();
        if (appointmentSelection) {
          appointmentSelection.textContent = 'Select one saved concept before opening the booking page.';
        }
        return;
      }

      updateAppointmentButtonLink(selectedItem.id);
    });

    fileInput?.addEventListener('change', async () => {
      const file = fileInput.files && fileInput.files[0];
      if (!file) {
        preparedUpload = null;
        preparedUploadPromise = null;
        if (uploadBox) {
          delete uploadBox.dataset.filled;
        }
        if (uploadPreview) {
          uploadPreview.hidden = true;
          uploadPreview.innerHTML = '';
        }
        if (uploadBadge) {
          uploadBadge.textContent = 'JPG / PNG / WEBP supported';
        }
        if (guestUploadName) {
          guestUploadName.textContent = 'Image';
        }
        if (guestUploadTrigger) {
          delete guestUploadTrigger.dataset.filled;
        }
        if (memberUploadName) {
          memberUploadName.textContent = 'Image';
        }
        if (memberUploadTrigger) {
          delete memberUploadTrigger.dataset.filled;
        }
        return;
      }

      if (uploadBadge) {
        uploadBadge.textContent = `Optimizing ${file.name}...`;
      }

      preparedUploadPromise = prepareUploadImage(file);

      try {
        const optimized = await preparedUploadPromise;
        const currentFile = fileInput.files && fileInput.files[0];
        if (!currentFile || !sameFile(currentFile, file)) {
          return;
        }

        preparedUpload = optimized;
        if (uploadBox) {
          uploadBox.dataset.filled = 'true';
        }
        if (uploadPreview) {
          uploadPreview.hidden = false;
          uploadPreview.innerHTML = imageMarkup(optimized.dataUrl, 'Customer reference image');
        }
        if (uploadBadge) {
          uploadBadge.textContent = `${file.name} · ${formatBytes(file.size)} -> ${formatBytes(optimized.byteSize)}`;
        }
        if (guestUploadName) {
          guestUploadName.textContent = file.name;
        }
        if (guestUploadTrigger) {
          guestUploadTrigger.dataset.filled = 'true';
        }
        if (memberUploadName) {
          memberUploadName.textContent = file.name;
        }
        if (memberUploadTrigger) {
          memberUploadTrigger.dataset.filled = 'true';
        }
      } catch (error) {
        preparedUpload = null;
        preparedUploadPromise = null;
        if (uploadBadge) {
          uploadBadge.textContent = `${file.name} · ${formatBytes(file.size)}`;
        }
        if (guestUploadName) {
          guestUploadName.textContent = file.name;
        }
        if (memberUploadName) {
          memberUploadName.textContent = file.name;
        }
        setStatus(status, error.message || 'Image optimization failed. Using the original upload may be less stable.', 'error');
      }
    });

    uploadBox?.addEventListener('click', (event) => {
      if (!fileInput || event.target === fileInput) {
        return;
      }

      if (typeof fileInput.showPicker === 'function') {
        try {
          fileInput.showPicker();
          return;
        } catch (error) {
          // Safari/iOS may reject showPicker; fall back to click below.
        }
      }

      fileInput.click();
    });

    guestUploadTrigger?.addEventListener('click', () => {
      openFilePicker();
    });

    memberUploadTrigger?.addEventListener('click', () => {
      openFilePicker();
    });

    guestAdvancedToggle?.addEventListener('click', () => {
      if (toggleAdvancedPanel(guestAdvancedOptions, guestAdvancedToggle)) {
        hasReviewedAdvancedControls = true;
      }
    });

    memberAdvancedToggle?.addEventListener('click', () => {
      if (toggleAdvancedPanel(memberAdvancedOptions, memberAdvancedToggle)) {
        hasReviewedAdvancedControls = true;
      }
    });

    function openFilePicker() {
      if (!fileInput) {
        return;
      }

      if (typeof fileInput.showPicker === 'function') {
        try {
          fileInput.showPicker();
          return;
        } catch (error) {
          // Fall through to click for browsers that reject showPicker.
        }
      }

      fileInput.click();
    }

    function toggleAdvancedPanel(panel, toggle) {
      if (!panel || !toggle) {
        return false;
      }

      const nextOpen = panel.hidden;
      setAdvancedPanelOpen(panel, toggle, nextOpen);
      return nextOpen;
    }

    function setAdvancedPanelOpen(panel, toggle, open) {
      if (!panel || !toggle) {
        return;
      }

      const nextOpen = Boolean(open);
      panel.hidden = !nextOpen;
      toggle.setAttribute('aria-expanded', nextOpen ? 'true' : 'false');
      const caret = toggle.querySelector('.pearl-designer__guest-prompt-action-caret');
      if (caret) {
        caret.textContent = nextOpen ? '−' : '+';
      }
    }

    function getActiveAdvancedControls() {
      return isLoggedInCustomer
        ? {
            panel: memberAdvancedOptions,
            toggle: memberAdvancedToggle,
            label: 'Material and pricing controls',
          }
        : {
            panel: guestAdvancedOptions,
            toggle: guestAdvancedToggle,
            label: 'Materials and options',
          };
    }

    function revealAdvancedControlsBeforeGenerate() {
      if (hasReviewedAdvancedControls) {
        return false;
      }

      const controls = getActiveAdvancedControls();
      if (!controls.panel || !controls.toggle) {
        return false;
      }

      hasReviewedAdvancedControls = true;
      setAdvancedPanelOpen(controls.panel, controls.toggle, true);
      setStatus(
        status,
        `Review ${controls.label}, then click generate again to start.`,
        'loading'
      );

      controls.panel.scrollIntoView({ behavior: 'smooth', block: 'center' });
      const firstField = controls.panel.querySelector('select, input, button, textarea');
      if (firstField && typeof firstField.focus === 'function') {
        window.setTimeout(() => firstField.focus({ preventScroll: true }), 180);
      }

      return true;
    }

    function getGenerationScrollTarget() {
      if (isLoggedInCustomer) {
        return historyDetail || appointmentBrowser || generatedFrame || estimateBlock || null;
      }

      return guestResultCard || generatedFrame || estimateBlock || null;
    }

    function scrollToGenerationInterface() {
      const target = getGenerationScrollTarget();
      if (!target || typeof target.scrollIntoView !== 'function') {
        return;
      }

      window.requestAnimationFrame(() => {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }

    form.addEventListener('submit', async (event) => {
      event.preventDefault();

      if (!isLoggedInCustomer && guestGenerationLocked) {
        redirectToLogin();
        return;
      }

      const formData = new FormData(form);
      const file = fileInput?.files && fileInput.files[0];
      let keepButtonDisabled = false;
      let startedRendering = false;

      try {
        const payload = {
          prompt: String(formData.get('prompt') || '').trim(),
          jewelryType: String(formData.get('jewelry_type') || ''),
          pearlType: String(formData.get('pearl_type') || ''),
          pearlSizeMm: Number(formData.get('pearl_size_mm') || 8),
          metalMaterial: String(formData.get('metal_material') || ''),
          diamondQuality: String(formData.get('diamond_quality') || ''),
          complexitySetting: Number(formData.get('complexity_setting') || 2),
          expediteProduction: formData.get('expedite_production') === 'on',
          customerEmail,
          customerName,
          customerId,
          customerOrderCount,
          shopDomain,
          visitorId,
        };

        if (!payload.prompt) {
          if (promptField && typeof promptField.focus === 'function') {
            promptField.focus();
          }
          throw new Error('Please enter a design prompt first.');
        }

        if (revealAdvancedControlsBeforeGenerate()) {
          return;
        }

        if (!isLoggedInCustomer) {
          if (!turnstileSiteKey) {
            throw new Error('Guest verification is not configured. Please add your Turnstile site key.');
          }
          if (!guestTurnstileToken) {
            guestPendingSubmitAfterVerification = true;
            await revealGuestVerification();
            setStatus(
              status,
              'Complete the quick verification to generate your complimentary concept.',
              'loading'
            );
            return;
          }
          payload.guestSessionId = guestSessionId;
          payload.turnstileToken = guestTurnstileToken;
        }

        setStatus(
          status,
          isLoggedInCustomer
            ? 'Generating your concept image and estimate. This usually takes 10-25 seconds...'
            : 'Preparing your complimentary concept. This usually takes 10-25 seconds...',
          'loading'
        );
        setSubmitButtonsDisabled(true);
        startedRendering = true;
        if (!isLoggedInCustomer) {
          renderGuestPendingState(payload);
          scrollToGenerationInterface();
        } else {
          setGeneratedFrameState('rendering');
          if (generatedFrame) {
            generatedFrame.innerHTML = renderingMarkup(renderingMessages);
          }
          if (estimateBlock) {
            estimateBlock.innerHTML = '';
          }
          if (notesBlock) {
            notesBlock.textContent = '';
          }
        }
        if (isLoggedInCustomer) {
          pendingHistoryItem = createPendingHistoryItem(payload);
          selectedGenerationId = String(pendingHistoryItem.id);
          renderHistoryGallery(recentGenerations);
          scrollToGenerationInterface();
        }

        if (file) {
          const optimized =
            preparedUpload && sameFile(preparedUpload.file, file)
              ? preparedUpload
              : await prepareUploadImageWithFallback(file);
          preparedUpload = optimized;
          payload.uploadedImageBase64 = optimized.dataUrl.split(',')[1];
          payload.uploadedImageMimeType = optimized.mimeType || 'image/jpeg';
        }

        if (!isLoggedInCustomer) {
          trackDesignerEvent('ai_designer_guest_generate_attempt', buildGuestAnalyticsProps(formData));
        }

        const response = await fetch(generateEndpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(payload),
        });

        const responseJson = await parseApiResponse(response);
        if (!response.ok || responseJson.ok === false) {
          throw new Error(responseJson.error || 'Generation failed. Please try again in a moment.');
        }

        if (responseJson.generatedImageBase64) {
          const mimeType = responseJson.generatedImageMimeType || 'image/png';
          const sourceDataUrl = `data:${mimeType};base64,${responseJson.generatedImageBase64}`;
          const normalizedOutput = await normalizeGeneratedOutputDataUrl(sourceDataUrl);
          if (generatedFrame) {
            generatedFrame.innerHTML = generatedImageMarkup(
              normalizedOutput.dataUrl,
              'AI pearl jewelry concept',
              {
                downloadHref: normalizedOutput.dataUrl,
                downloadName: buildGeneratedImageDownloadName({
                  jewelryType: payload.jewelryType,
                  generationId: responseJson.generationId || 'guest',
                  mimeType: normalizedOutput.mimeType,
                }),
              }
            );
            setGeneratedFrameState('revealed');
          }
          if (isLoggedInCustomer) {
            await persistNormalizedGeneratedOutput(responseJson, normalizedOutput);
            await persistHistoryThumbnail(responseJson, normalizedOutput);
          }
        } else {
          if (generatedFrame) {
            setGeneratedFrameState('empty');
            generatedFrame.innerHTML = placeholderMarkup('No image returned', 'The model only returned text this time. Try refining the prompt and generate again.');
          }
        }

        if (estimateBlock) {
          estimateBlock.innerHTML = renderEstimate(responseJson.estimate, currency);
        }
        renderHistoryMeta({
          jewelryType: payload.jewelryType,
          pearlType: payload.pearlType,
          metalMaterial: payload.metalMaterial,
          diamondQuality: payload.diamondQuality,
        });
        if (notesBlock) {
          notesBlock.innerHTML = renderNotesMarkup(
            responseJson.notes || 'This reference image works well as a first-round concept for consultation and custom approval.'
          );
        }
        if (isLoggedInCustomer) {
          pendingHistoryItem = null;
          selectedGenerationId = String(responseJson.generationId || selectedGenerationId || '');
          updateQuota(responseJson.quota);
          await loadHistory({ selectNewest: true, selectGenerationId: selectedGenerationId });
          setStatus(status, 'Your concept image and first estimate are ready. You can refine the prompt and generate again.', 'success');
        } else {
          markGuestTrialUsed(shopDomain);
          lockGuestGeneration();
          showGuestLoginGate();
          trackDesignerEvent('ai_designer_guest_generate_success', buildGuestAnalyticsProps(formData));
          setStatus(
            status,
            'Your complimentary concept is ready below. Sign in to save it and continue generating more designs.',
            'success'
          );
          keepButtonDisabled = false;
        }
      } catch (error) {
        if (isLoggedInCustomer && pendingHistoryItem) {
          pendingHistoryItem = null;
          renderHistoryGallery(recentGenerations);
        }
        if (startedRendering) {
          if (!isLoggedInCustomer) {
            renderGuestFailureState(error.message || 'Please review the brief and try again.', {
              jewelryType: String(formData.get('jewelry_type') || ''),
              pearlType: String(formData.get('pearl_type') || ''),
              metalMaterial: String(formData.get('metal_material') || ''),
              diamondQuality: String(formData.get('diamond_quality') || ''),
            });
          } else if (generatedFrame) {
            setGeneratedFrameState('error');
            generatedFrame.innerHTML = placeholderMarkup('Generation failed', error.message || 'Please review the API setup and try again.');
          }
        }
        setStatus(status, error.message || 'Generation failed', 'error');
        if (!isLoggedInCustomer) {
          if (startedRendering) {
            trackDesignerEvent(
              'ai_designer_guest_generate_fail',
              buildGuestAnalyticsProps(formData, {
                error_message: String(error.message || 'Generation failed'),
              })
            );
          }
          resetGuestVerification();
        }
        if (
          !isLoggedInCustomer &&
          /complimentary guest concept|sign in to continue generating/i.test(
            String(error.message || '')
          )
          ) {
          markGuestTrialUsed(shopDomain);
          lockGuestGeneration();
          showGuestLoginGate();
          keepButtonDisabled = false;
        }
      } finally {
        setSubmitButtonsDisabled(keepButtonDisabled);
      }
    });

    async function bootstrapAuthenticatedCustomer() {
      await loadQuota({
        claimGuestGeneration: Boolean(guestSessionId && hasGuestTrialBeenUsed(shopDomain)),
      });
      await loadHistory();
    }

    async function loadQuota(options = {}) {
      setStatus(status, 'Checking your customer session and daily quota...', 'loading');

      try {
        const requestBody = {
          customerEmail,
          customerName,
          customerId,
          customerOrderCount,
          shopDomain,
          visitorId,
        };
        if (options.claimGuestGeneration && guestSessionId) {
          requestBody.guestSessionId = guestSessionId;
        }

        const response = await fetch(statusEndpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(requestBody),
        });

        const responseJson = await parseApiResponse(response);
        if (!response.ok || responseJson.ok === false) {
          throw new Error(responseJson.error || 'Access validation failed.');
        }

        updateQuota(responseJson.quota);

        if (responseJson.quota?.isBlocked) {
          setSubmitButtonsDisabled(true);
          setStatus(status, 'This account is currently paused. Please contact your brand advisor.', 'error');
          return;
        }

        if (Number(responseJson.quota?.dailyRemaining || 0) <= 0) {
          setSubmitButtonsDisabled(true);
          setStatus(status, 'You have used all AI generations available for today.', 'error');
          return;
        }

        if (Number(responseJson.quota?.monthlyRemaining || 0) <= 0) {
          setSubmitButtonsDisabled(true);
          setStatus(status, 'You have used all AI generations available for this month.', 'error');
          return;
        }

        setSubmitButtonsDisabled(false);
        if (responseJson.claimedGuestGeneration) {
          setStatus(
            status,
            `Your complimentary guest concept has been saved to this account. ${responseJson.quota?.dailyRemaining ?? 0} left today and ${responseJson.quota?.monthlyRemaining ?? 0} left this month.`,
            'success'
          );
        } else {
          setStatus(status, '', '');
        }
        return responseJson;
      } catch (error) {
        setSubmitButtonsDisabled(true);
        setStatus(status, error.message || 'Unable to load your quota information.', 'error');
        return null;
      }
    }

    async function revealGuestVerification() {
      if (isLoggedInCustomer || !guestVerification) {
        return;
      }

      if (!turnstileSiteKey) {
        setStatus(
          status,
          'Guest verification is not configured. Add a Turnstile site key to enable complimentary guest generation.',
          'error'
        );
        setSubmitButtonsDisabled(true);
        return;
      }

      if (guestVerification.hidden) {
        guestVerification.hidden = false;
        trackDesignerEvent('ai_designer_guest_verification_shown', buildGuestAnalyticsProps());
      }

      try {
        await ensureTurnstileApi();
        if (!guestTurnstile || guestTurnstileWidgetId !== null || !window.turnstile) {
          if (guestTurnstile) {
            guestTurnstile.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
          return;
        }

        guestTurnstileWidgetId = window.turnstile.render(guestTurnstile, {
          sitekey: turnstileSiteKey,
          theme: 'light',
          callback(token) {
            guestTurnstileToken = String(token || '');
            trackDesignerEvent('ai_designer_guest_verification_pass', buildGuestAnalyticsProps());
            if (guestPendingSubmitAfterVerification) {
              guestPendingSubmitAfterVerification = false;
              window.requestAnimationFrame(() => form.requestSubmit());
            }
          },
          'expired-callback'() {
            guestTurnstileToken = '';
          },
          'error-callback'() {
            guestTurnstileToken = '';
          },
        });
        guestTurnstile.scrollIntoView({ behavior: 'smooth', block: 'center' });
      } catch (error) {
        setStatus(status, 'Unable to load guest verification. Please refresh and try again.', 'error');
        setSubmitButtonsDisabled(true);
      }
    }

    function resetGuestVerification() {
      if (isLoggedInCustomer) {
        return;
      }

      guestPendingSubmitAfterVerification = false;
      guestTurnstileToken = '';
      if (
        guestTurnstileWidgetId !== null &&
        window.turnstile &&
        typeof window.turnstile.reset === 'function'
      ) {
        window.turnstile.reset(guestTurnstileWidgetId);
      }
    }

    function updateQuota(quota) {
      if (!quota) {
        return;
      }

      if (quotaValue) {
        const dailyRemaining = Number(quota.dailyRemaining ?? quota.remaining ?? 0);
        const dailyLimit = Number(quota.dailyLimit ?? quota.limit ?? 0);
        quotaValue.textContent = `${dailyRemaining}/${dailyLimit}`;
      }
    }

    async function loadHistory(options = {}) {
      if (!appointmentGallery) {
        return;
      }

      const cachedGenerations = options.bypassCache ? [] : readHistorySessionCache(historyCacheKey);
      const shouldRenderCachedHistory = Array.isArray(cachedGenerations) && cachedGenerations.length && !pendingHistoryItem;

      if (shouldRenderCachedHistory) {
        startHistoryLoadProgress({ lightweight: true });
        recentGenerations = cachedGenerations;
        if (
          options.selectGenerationId &&
          recentGenerations.some((item) => String(item.id) === String(options.selectGenerationId))
        ) {
          selectedGenerationId = String(options.selectGenerationId);
        } else if (!recentGenerations.some((item) => String(item.id) === selectedGenerationId)) {
          selectedGenerationId = recentGenerations[0] ? String(recentGenerations[0].id) : '';
        }
        renderHistoryGallery(recentGenerations);
      } else {
        startHistoryLoadProgress({ lightweight: false });
        appointmentGallery.innerHTML = historySkeletonMarkup(HISTORY_SKELETON_CARD_COUNT);
        if (appointmentSelection) {
          appointmentSelection.textContent = 'Loading your recent concepts...';
        }
      }

      try {
        const response = await fetch(historyEndpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            customerEmail,
            customerName,
            customerId,
            customerOrderCount,
            shopDomain,
          }),
        });

        const responseJson = await parseApiResponse(response);
        if (!response.ok || responseJson.ok === false) {
          throw new Error(responseJson.error || 'Unable to load your recent concepts.');
        }

        recentGenerations = Array.isArray(responseJson.generations)
          ? responseJson.generations
          : [];
        writeHistorySessionCache(historyCacheKey, recentGenerations);
        if (
          options.selectGenerationId &&
          recentGenerations.some((item) => String(item.id) === String(options.selectGenerationId))
        ) {
          selectedGenerationId = String(options.selectGenerationId);
        } else if (options.selectNewest && recentGenerations[0]) {
          selectedGenerationId = String(recentGenerations[0].id);
        } else if (!recentGenerations.some((item) => String(item.id) === selectedGenerationId)) {
          selectedGenerationId = recentGenerations[0] ? String(recentGenerations[0].id) : '';
        }

        renderHistoryGallery(recentGenerations);
        completeHistoryLoadProgress();
      } catch (error) {
        if (shouldRenderCachedHistory) {
          completeHistoryLoadProgress({ failed: true });
          return;
        }

        recentGenerations = [];
        selectedGenerationId = '';
        appointmentGallery.innerHTML = placeholderMarkup(
          'Unable to load your shortlist',
          error.message || 'Please refresh and try again.'
        );
        if (appointmentSelection) {
          appointmentSelection.textContent = 'We could not load your recent concepts just now.';
        }
        completeHistoryLoadProgress({ failed: true });
      }
    }

    function renderHistoryGallery(items) {
      if (!appointmentGallery) {
        return;
      }

      const displayItems = getDisplayHistoryItems(items);

      if (!displayItems.length) {
        if (appointmentButton) {
          appointmentButton.setAttribute('aria-disabled', 'true');
          appointmentButton.setAttribute('href', appointmentBaseUrl);
        }
        appointmentGallery.innerHTML = placeholderMarkup(
          'Your concept shortlist will appear here',
          'Generate a design and we will automatically show your latest ten concepts for consultation.'
        );
        if (appointmentSelection) {
          appointmentSelection.textContent = 'Generate a design to start building your consultation shortlist.';
        }
        renderSelectedHistoryDetail(null);
        return;
      }

      appointmentGallery.innerHTML = displayItems
        .map((item, index) => {
          const isSelected = String(item.id) === selectedGenerationId;
          const conceptLabel = formatHistoryConceptTitle(item);
          const generatedAtLabel = formatHistoryGeneratedAt(item?.createdAt);

          return `
            <button
              class="pearl-designer__appointment-thumb${isSelected ? ' is-selected' : ''}${item?.isPendingGeneration ? ' is-pending' : ''}"
              type="button"
              data-role="history-select"
              data-generation-id="${escapeHtml(String(item.id))}"
              aria-pressed="${isSelected ? 'true' : 'false'}"
              aria-label="${escapeHtml(`${conceptLabel} ${isSelected ? 'selected' : 'select concept'}`)}"
            >
              ${renderHistoryThumbMedia(item, conceptLabel, historyImageEndpoint, index, isSelected)}
              <span class="pearl-designer__appointment-thumb-copy">
                <strong>${escapeHtml(conceptLabel)}</strong>
                <span>${escapeHtml(generatedAtLabel)}</span>
              </span>
            </button>
          `;
        })
        .join('');

      const selectedItem = displayItems.find((item) => String(item.id) === selectedGenerationId) || displayItems[0];
      if (appointmentSelection && selectedItem) {
        appointmentSelection.textContent = getAppointmentSelectionCopy(selectedItem);
      }
      renderSelectedHistoryDetail(selectedItem);
      warmLikelyHistoryImages(displayItems, selectedItem);
      if (appointmentButton) {
        appointmentButton.setAttribute('aria-disabled', selectedItem && !selectedItem.isPendingGeneration ? 'false' : 'true');
        if (selectedItem && !selectedItem.isPendingGeneration) {
          updateAppointmentButtonLink(selectedItem.id);
        } else {
          appointmentButton.setAttribute('href', appointmentBaseUrl);
        }
      }
    }

    function getSelectedGeneration() {
      const displayItems = getDisplayHistoryItems(recentGenerations);
      return (
        displayItems.find((item) => String(item.id) === selectedGenerationId) ||
        displayItems[0] ||
        null
      );
    }

    function renderSelectedHistoryDetail(item) {
      if (!generatedFrame || !estimateBlock || !notesBlock) {
        return;
      }

      const renderToken = ++selectedHistoryRenderToken;

      if (item?.isPendingGeneration) {
        setGeneratedFrameState('rendering');
        generatedFrame.innerHTML = renderingMarkup(renderingMessages);
        estimateBlock.innerHTML = `
          <div class="pearl-designer__estimate-range">
            <span class="pearl-designer__estimate-label">Price Range</span>
            <strong class="pearl-designer__estimate-value">Generating estimate</strong>
          </div>
          <p class="pearl-designer__estimate-copy">Your newest concept is being generated now. It will replace this placeholder automatically when ready.</p>
        `;
        notesBlock.innerHTML = renderNotesMarkup(
          'Your newest concept is rendering. The latest thumbnail will stay pinned in the first slot until generation is complete.'
        );
        renderHistoryMeta(item);
        return;
      }

      if (!item) {
        setGeneratedFrameState('idle');
        generatedFrame.innerHTML = placeholderMarkup(
          'Waiting to generate',
          'Your newest saved concept will appear here automatically after generation.'
        );
        estimateBlock.innerHTML = `
          <div class="pearl-designer__estimate-range">
            <span class="pearl-designer__estimate-label">Price Range</span>
            <strong class="pearl-designer__estimate-value">Waiting to generate</strong>
          </div>
          <p class="pearl-designer__estimate-copy">The selected concept will show a full estimate breakdown here, including material pricing and production lead time.</p>
        `;
        notesBlock.innerHTML = renderNotesMarkup(
          'Model notes and styling observations will appear here after you generate or select a saved concept.'
        );
        renderHistoryMeta(null);
        return;
      }

      const conceptLabel = humanizeLabel(item.jewelryType) || 'Saved jewelry concept';
      const normalizedEstimate = normalizeEstimatePayload(item, currency);
      const fullImageSrc = getHistoryFullImageSrc(item, historyImageEndpoint);
      const fallbackSrc = buildHistoryImageFallbackSrc(item, historyImageEndpoint, 'full');
      const downloadHref = buildHistoryImageDownloadSrc(item, historyImageEndpoint);
      const downloadName = buildGeneratedImageDownloadName({
        jewelryType: item.jewelryType,
        createdAt: item.createdAt,
        generationId: item.id,
      });
      const commitSelectedImage = () => {
        if (renderToken !== selectedHistoryRenderToken) {
          return;
        }
        setGeneratedFrameState('revealed');
        generatedFrame.innerHTML = generatedImageMarkup(
          fullImageSrc,
          conceptLabel,
          {
            loading: 'eager',
            fetchPriority: 'high',
            fallbackSrc,
            width: GENERATED_IMAGE_TARGET_WIDTH,
            height: GENERATED_IMAGE_TARGET_HEIGHT,
            downloadHref,
            downloadName,
          }
        );
      };

      estimateBlock.innerHTML =
        renderEstimate(normalizedEstimate, currency) ||
        `
          <div class="pearl-designer__estimate-range">
            <span class="pearl-designer__estimate-label">Price Range</span>
            <strong class="pearl-designer__estimate-value">Estimate unavailable</strong>
          </div>
          <p class="pearl-designer__estimate-copy">This saved concept does not have a full estimate payload yet, but it can still be used for consultation.</p>
        `;
      notesBlock.innerHTML = renderNotesMarkup(
        item.notes || 'This saved concept is ready for a pricing review and private consultation.'
      );
      renderHistoryMeta(item);
      preloadHistoryImage(fullImageSrc)
        .catch(() => null)
        .finally(commitSelectedImage);
    }

    function updateAppointmentButtonLink(generationId) {
      if (!appointmentButton) {
        return;
      }
      const buttonLabel = appointmentButton.querySelector('.pearl-designer__button-label');

      if (buttonLabel) {
        buttonLabel.textContent = 'Setup Appointment';
      }

      try {
        const bookingUrl = new URL(appointmentBaseUrl, window.location.origin);
        bookingUrl.searchParams.set('generation_id', String(generationId));
        appointmentButton.setAttribute('href', bookingUrl.pathname + bookingUrl.search);
      } catch (error) {
        const separator = appointmentBaseUrl.includes('?') ? '&' : '?';
        appointmentButton.setAttribute(
          'href',
          `${appointmentBaseUrl}${separator}generation_id=${encodeURIComponent(String(generationId))}`
        );
      }
      appointmentButton.setAttribute('aria-disabled', 'false');
      appointmentButton.setAttribute('target', '_blank');
      appointmentButton.setAttribute('rel', 'noopener noreferrer');
    }

  function getAppointmentSelectionCopy(selectedItem) {
    if (selectedItem?.isPendingGeneration) {
      return 'Your newest concept is generating now. It is pinned in the first slot and will be ready shortly.';
    }
    const conceptLabel = humanizeLabel(selectedItem.jewelryType) || 'Concept';
      if (selectedItem.hasAppointmentBooking) {
        return `${conceptLabel} selected. An appointment request already exists for this concept, and you can reopen it directly.`;
      }
    return `${conceptLabel} selected for your consultation. Click Setup Appointment to continue.`;
  }

  function formatHistoryConceptTitle(item) {
    if (item?.isPendingGeneration) {
      return 'Generating concept';
    }
    const metalLabel = humanizeLabel(item?.metalMaterial) || '';
    const jewelryLabel = humanizeLabel(item?.jewelryType) || 'Concept';

    return [metalLabel, jewelryLabel].filter(Boolean).join(' ') || 'Saved jewelry concept';
  }

  function formatHistoryGeneratedAt(value) {
    if (String(value || '').trim() === '__pending__') {
      return 'Generating now';
    }
    const normalized = String(value || '').trim();
    if (!normalized) {
      return 'Generation time unavailable';
    }

    const date = new Date(normalized);
    if (Number.isNaN(date.getTime())) {
      return normalized;
    }

    try {
      return new Intl.DateTimeFormat(undefined, {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
      }).format(date);
    } catch (error) {
      return date.toLocaleString();
    }
  }

    function renderHistoryMeta(item) {
      if (!historyMeta) {
        return;
      }

      const specs = [
        {
          label: 'Jewelry',
          value: item ? humanizeLabel(item.jewelryType) || 'N/A' : 'Waiting to generate',
        },
        {
          label: 'Pearl',
          value: item ? humanizeLabel(item.pearlType) || 'N/A' : 'Waiting to generate',
        },
        {
          label: 'Metal',
          value: item ? humanizeLabel(item.metalMaterial) || 'N/A' : 'Waiting to generate',
        },
        {
          label: 'Gemstone',
          value: item ? humanizeLabel(item.diamondQuality) || 'N/A' : 'Waiting to generate',
        },
      ];

      historyMeta.innerHTML = specs
        .map(
          (spec) => `
            <div class="pearl-designer__appointment-detail-stat">
              <span>${escapeHtml(spec.label)}</span>
              <strong>${escapeHtml(spec.value)}</strong>
            </div>
          `
        )
        .join('');
    }

    function renderHistoryThumbMedia(item, conceptLabel, historyImageEndpoint, index, isSelected) {
      if (item?.isPendingGeneration) {
        return `
          <div class="pearl-designer__appointment-thumb-media pearl-designer__appointment-thumb-media--pending" aria-hidden="true">
            <span class="pearl-designer__appointment-thumb-pulse"></span>
            <span class="pearl-designer__appointment-thumb-loader"></span>
            <span class="pearl-designer__appointment-thumb-state">Generating</span>
          </div>
        `;
      }

      const thumbSrc = getHistoryThumbnailSrc(item, historyImageEndpoint);
      const imageOptions = getHistoryThumbImageOptions(item, index, isSelected, historyImageEndpoint);
      return `
        <div class="pearl-designer__appointment-thumb-media">
          ${imageMarkup(thumbSrc, conceptLabel, imageOptions)}
        </div>
      `;
    }

    function getHistoryThumbImageOptions(item, index, isSelected, historyImageEndpoint) {
      const prioritized = shouldUseCompactHistoryLoading()
        ? (isSelected || index === 0)
        : (isSelected || index < 3);
      const highestPriority = isSelected || index === 0;

      return {
        loading: prioritized ? 'eager' : 'lazy',
        fetchPriority: highestPriority ? 'high' : '',
        fallbackSrc: buildHistoryImageFallbackSrc(item, historyImageEndpoint, 'thumb'),
        width: HISTORY_THUMB_MAX_DIMENSION,
        height: HISTORY_THUMB_MAX_DIMENSION,
      };
    }

    function preloadHistoryImage(src) {
      const normalizedSrc = String(src || '').trim();
      if (!normalizedSrc) {
        return Promise.reject(new Error('Image source missing.'));
      }

      if (preloadedHistoryImageUrls.has(normalizedSrc)) {
        return Promise.resolve(normalizedSrc);
      }

      if (historyImagePreloadPromises.has(normalizedSrc)) {
        return historyImagePreloadPromises.get(normalizedSrc);
      }

      const preloadPromise = new Promise((resolve, reject) => {
        const image = new Image();
        image.decoding = 'async';
        image.onload = () => {
          preloadedHistoryImageUrls.add(normalizedSrc);
          historyImagePreloadPromises.delete(normalizedSrc);
          resolve(normalizedSrc);
        };
        image.onerror = () => {
          historyImagePreloadPromises.delete(normalizedSrc);
          reject(new Error(`Failed to preload image: ${normalizedSrc}`));
        };
        image.src = normalizedSrc;
      });

      historyImagePreloadPromises.set(normalizedSrc, preloadPromise);
      return preloadPromise;
    }

    function warmLikelyHistoryImages(displayItems, selectedItem) {
      if (!isLoggedInCustomer || !Array.isArray(displayItems) || !displayItems.length) {
        return;
      }

      const selectedRealItem = selectedItem?.isPendingGeneration ? null : selectedItem;
      if (!selectedRealItem) {
        return;
      }

      preloadHistoryImage(getHistoryFullImageSrc(selectedRealItem, historyImageEndpoint)).catch(() => null);

      if (shouldUseCompactHistoryLoading()) {
        return;
      }

      const adjacentItem = getAdjacentHistoryItem(displayItems, selectedRealItem);
      if (!adjacentItem) {
        return;
      }

      scheduleIdleTask(() => {
        preloadHistoryImage(getHistoryFullImageSrc(adjacentItem, historyImageEndpoint)).catch(() => null);
      });
    }

    function getAdjacentHistoryItem(displayItems, selectedItem) {
      const currentIndex = displayItems.findIndex((item) => String(item?.id) === String(selectedItem?.id));
      if (currentIndex === -1) {
        return null;
      }

      const adjacentCandidates = [displayItems[currentIndex + 1], displayItems[currentIndex - 1]];
      return (
        adjacentCandidates.find((item) => item && !item.isPendingGeneration) ||
        null
      );
    }

    function shouldUseCompactHistoryLoading() {
      const queries = ['(max-width: 768px)', '(hover: none) and (pointer: coarse)'];

      return queries.some((query) => {
        try {
          return window.matchMedia(query).matches;
        } catch (error) {
          return false;
        }
      });
    }

    function ensureHistoryLoadProgressElements() {
      if (!appointmentBrowser) {
        return null;
      }

      if (historyLoadProgressState.root && historyLoadProgressState.copy) {
        return historyLoadProgressState;
      }

      const root = document.createElement('div');
      root.className = 'pearl-designer__history-loading';
      root.hidden = true;
      root.setAttribute('aria-live', 'polite');
      root.setAttribute('aria-atomic', 'true');
      root.innerHTML = `
        <div class="pearl-designer__history-loading-copy">
          <strong class="pearl-designer__history-loading-title">Loading your generation history</strong>
          <span class="pearl-designer__history-loading-subtitle">Preparing your recent concepts...</span>
        </div>
        <div class="pearl-designer__history-loading-track" aria-hidden="true">
          <span class="pearl-designer__history-loading-fill"></span>
        </div>
      `;
      appointmentBrowser.insertBefore(root, appointmentGallery);
      historyLoadProgressState.root = root;
      historyLoadProgressState.copy = root.querySelector('.pearl-designer__history-loading-subtitle');
      return historyLoadProgressState;
    }

    function startHistoryLoadProgress(options = {}) {
      const progressState = ensureHistoryLoadProgressElements();
      if (!progressState?.root) {
        return;
      }

      const lightweight = Boolean(options.lightweight);
      const token = progressState.token + 1;
      const startTime = performance.now();
      const initialProgress = lightweight ? 0.16 : 0.08;
      const cruiseTarget = lightweight ? HISTORY_PROGRESS_LIGHT_TARGET : HISTORY_PROGRESS_FULL_TARGET;

      cancelHistoryLoadProgressMotion();
      progressState.token = token;
      progressState.startedAt = startTime;
      progressState.currentProgress = initialProgress;
      progressState.root.hidden = false;
      progressState.root.dataset.state = 'loading';
      progressState.root.dataset.mode = lightweight ? 'lightweight' : 'full';
      if (progressState.copy) {
        progressState.copy.textContent = lightweight
          ? 'Refreshing your recent concepts...'
          : 'Preparing your recent concepts...';
      }
      setHistoryLoadProgressValue(initialProgress);

      const tick = (now) => {
        if (progressState.token !== token) {
          return;
        }

        const elapsed = now - startTime;
        let nextProgress = initialProgress;

        if (elapsed <= HISTORY_PROGRESS_INITIAL_PHASE_MS) {
          const ratio = elapsed / HISTORY_PROGRESS_INITIAL_PHASE_MS;
          nextProgress =
            initialProgress +
            (HISTORY_PROGRESS_INITIAL_TARGET - initialProgress) * Math.max(0, Math.min(1, ratio));
        } else {
          const cruiseElapsed = elapsed - HISTORY_PROGRESS_INITIAL_PHASE_MS;
          const cruiseRatio = Math.max(0, Math.min(1, cruiseElapsed / HISTORY_PROGRESS_CRUISE_PHASE_MS));
          nextProgress =
            HISTORY_PROGRESS_INITIAL_TARGET +
            (cruiseTarget - HISTORY_PROGRESS_INITIAL_TARGET) * (1 - Math.exp(-2.2 * cruiseRatio));
        }

        progressState.currentProgress = Math.max(
          progressState.currentProgress,
          Math.min(cruiseTarget, nextProgress)
        );
        setHistoryLoadProgressValue(progressState.currentProgress);
        progressState.rafId = window.requestAnimationFrame(tick);
      };

      progressState.rafId = window.requestAnimationFrame(tick);
    }

    function completeHistoryLoadProgress(options = {}) {
      const progressState = historyLoadProgressState;
      if (!progressState.root || progressState.root.hidden) {
        return;
      }

      const token = progressState.token + 1;
      const failed = Boolean(options.failed);
      const elapsed = performance.now() - progressState.startedAt;
      const remainingVisibleMs = Math.max(0, HISTORY_PROGRESS_MIN_VISIBLE_MS - elapsed);

      cancelHistoryLoadProgressMotion();
      progressState.token = token;

      progressState.timeoutIds.push(
        window.setTimeout(() => {
          if (progressState.token !== token || !progressState.root) {
            return;
          }

          setHistoryLoadProgressValue(1);
          progressState.root.dataset.state = failed ? 'error' : 'complete';

          progressState.timeoutIds.push(
            window.setTimeout(() => {
              if (progressState.token !== token || !progressState.root) {
                return;
              }

              progressState.root.dataset.state = 'closing';

              progressState.timeoutIds.push(
                window.setTimeout(() => {
                  if (progressState.token !== token || !progressState.root) {
                    return;
                  }

                  progressState.root.hidden = true;
                  delete progressState.root.dataset.state;
                  delete progressState.root.dataset.mode;
                  progressState.currentProgress = 0;
                  setHistoryLoadProgressValue(0);
                }, 200)
              );
            }, failed ? 180 : 240)
          );
        }, remainingVisibleMs)
      );
    }

    function cancelHistoryLoadProgressMotion() {
      const progressState = historyLoadProgressState;
      if (progressState.rafId) {
        window.cancelAnimationFrame(progressState.rafId);
        progressState.rafId = 0;
      }

      if (progressState.timeoutIds.length) {
        progressState.timeoutIds.forEach((timeoutId) => window.clearTimeout(timeoutId));
        progressState.timeoutIds = [];
      }
    }

    function setHistoryLoadProgressValue(value) {
      const progressState = historyLoadProgressState;
      if (!progressState.root) {
        return;
      }

      const clamped = Math.max(0, Math.min(1, Number(value) || 0));
      progressState.root.style.setProperty('--pearl-history-progress', clamped.toFixed(4));
    }

    function getDisplayHistoryItems(items) {
      const normalizedItems = Array.isArray(items) ? items : [];
      if (!pendingHistoryItem) {
        return normalizedItems;
      }

      return [
        pendingHistoryItem,
        ...normalizedItems.filter((item) => String(item?.id) !== String(pendingHistoryItem.id)),
      ].slice(0, 10);
    }

    function createPendingHistoryItem(payload) {
      return {
        id: '__pending_generation__',
        createdAt: '__pending__',
        isPendingGeneration: true,
        jewelryType: payload?.jewelryType || '',
        pearlType: payload?.pearlType || '',
        metalMaterial: payload?.metalMaterial || '',
        diamondQuality: payload?.diamondQuality || '',
      };
    }

    async function persistNormalizedGeneratedOutput(responseJson, normalizedOutput) {
      const generationId = Number(responseJson?.generationId);
      if (!generationId || !normalizedOutput?.dataUrl) {
        return;
      }

      try {
        await fetch(normalizeOutputEndpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            generationId,
            normalizedImageBase64: normalizedOutput.dataUrl.split(',')[1],
            normalizedImageMimeType: normalizedOutput.mimeType,
            customerEmail,
            customerName,
            customerId,
            customerOrderCount,
            shopDomain,
          }),
        });
      } catch (error) {
        return;
      }
    }

    async function persistHistoryThumbnail(responseJson, sourceImage) {
      const generationId = Number(responseJson?.generationId);
      const sourceDataUrl = String(sourceImage?.dataUrl || '').trim();

      if (!generationId || !sourceDataUrl) {
        return;
      }

      try {
        const thumbnail = await createHistoryThumbnailDataUrl(sourceDataUrl);

        await fetch(historyThumbnailEndpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            generationId,
            thumbnailBase64: thumbnail.dataUrl.split(',')[1],
            thumbnailMimeType: thumbnail.mimeType,
            customerEmail,
            customerName,
            customerId,
            customerOrderCount,
            shopDomain,
          }),
        });
      } catch (error) {
        return;
      }
    }

    function setGeneratedFrameState(state) {
      if (generatedFrame) {
        generatedFrame.dataset.state = state;
      }
    }

    function showGuestLoginGate(options = {}) {
      if (guestLoginGate) {
        guestLoginGate.hidden = false;
      }
    }

    function lockGuestGeneration() {
      guestGenerationLocked = true;
      setSubmitButtonsDisabled(false);
      setSubmitButtonLabels('Sign In');
    }

    function redirectToLogin() {
      releaseOpeningIntroScrollLock();
      if (resolvedLoginUrl) {
        window.location.assign(resolvedLoginUrl);
      }
    }

    function scrollToDesignerForm() {
      releaseOpeningIntroScrollLock();
      form.scrollIntoView({ behavior: 'smooth', block: 'start' });
      if (shouldAutoFocusPrompt() && promptField && typeof promptField.focus === 'function') {
        window.setTimeout(() => {
          promptField.focus({ preventScroll: true });
        }, 420);
      }
    }

    function shouldAutoFocusPrompt() {
      const mediaQueries = [
        '(max-width: 768px)',
        '(hover: none) and (pointer: coarse)',
      ];

      return !mediaQueries.some((query) => {
        try {
          return window.matchMedia(query).matches;
        } catch (error) {
          return false;
        }
      });
    }

    function renderGuestSamples() {
      if (isLoggedInCustomer || !guestSamplesSection || !guestSamplesGrid) {
        return;
      }

      if (guestSamplesGrid.children.length > 0) {
        guestSamplesSection.hidden = false;
        return;
      }

      primeOpeningIntroAssets().then((items) => {
        if (!Array.isArray(items) || !items.length) {
          guestSamplesSection.hidden = true;
          if (guestSamplesCta) {
            guestSamplesCta.hidden = true;
          }
          return;
        }

        guestSamplesGrid.innerHTML = items
          .slice(0, 5)
          .map((item, index) => {
            const preset = GUEST_SAMPLE_PRESETS[index % GUEST_SAMPLE_PRESETS.length];
            return `
              <article class="pearl-designer__sample-card">
                <div class="pearl-designer__sample-card-media">
                  <img src="${escapeHtml(item.imageUrl)}" alt="${escapeHtml(item.alt || preset.label)}" loading="lazy" decoding="async">
                </div>
                <div class="pearl-designer__sample-card-body">
                  <strong class="pearl-designer__sample-card-title">${escapeHtml(preset.label)}</strong>
                  <span class="pearl-designer__sample-card-range">${escapeHtml(preset.range)}</span>
                </div>
              </article>
            `;
          })
          .join('');
        guestSamplesSection.hidden = false;
      });
    }

    function buildGuestAnalyticsProps(formData, extra = {}) {
      const source = formData instanceof FormData ? formData : new FormData(form);
      return {
        page_type: 'guest',
        shop_domain: shopDomain,
        visitor_id: visitorId,
        guest_session_id: guestSessionId,
        influencer_code: influencerTracking.code || '',
        campaign_handle: influencerTracking.campaignHandle || '',
        utm_source: influencerTracking.utmSource || '',
        utm_medium: influencerTracking.utmMedium || '',
        utm_campaign: influencerTracking.utmCampaign || '',
        has_reference_image: Boolean(fileInput?.files && fileInput.files[0]),
        jewelry_type: String(source.get('jewelry_type') || ''),
        used_advanced_options: hasAdvancedGuestSelections(source),
        page_path: window.location.pathname,
        ...extra,
      };
    }
  });

  function renderEstimate(estimate, fallbackCurrency) {
    if (!estimate) {
      return '';
    }

    const normalizedEstimate = normalizeEstimatePayload(estimate, fallbackCurrency);
    if (!normalizedEstimate) {
      return '';
    }

    const formatter = new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: normalizedEstimate.currency || fallbackCurrency || 'USD',
      maximumFractionDigits: 0,
    });

    const rows = Array.isArray(normalizedEstimate.breakdown)
      ? normalizedEstimate.breakdown
          .map(
            (item) =>
              `<div class="pearl-designer__breakdown-row"><span>${escapeHtml(item.label)}</span><strong>${escapeHtml(formatBreakdownAmount(item.amount, formatter))}</strong></div>`
          )
          .join('')
      : '';

    return `
      <div class="pearl-designer__estimate-range">
        <span class="pearl-designer__estimate-label">Price Range</span>
        <strong class="pearl-designer__estimate-value">${formatter.format(normalizedEstimate.minimum)} - ${formatter.format(normalizedEstimate.maximum)}</strong>
      </div>
      <p class="pearl-designer__estimate-copy">${escapeHtml(normalizedEstimate.summary || '')}</p>
      <p class="pearl-designer__estimate-copy">Estimated production lead time: ${escapeHtml(normalizedEstimate.leadTimeDays || '10-18')} days.</p>
      <div class="pearl-designer__breakdown">${rows}</div>
    `;
  }

  function imageMarkup(src, alt, options = {}) {
    return `<img src="${escapeHtml(src)}" alt="${escapeHtml(alt)}"${buildImageAttributeString(options)}>`;
  }

  function generatedImageMarkup(src, alt, options = {}) {
    const downloadHref = String(options?.downloadHref || '').trim();
    const downloadName = String(options?.downloadName || '').trim();
    const downloadMarkup = downloadHref
      ? `
        <a
          class="pearl-designer__generated-download"
          href="${escapeHtml(downloadHref)}"
          download="${escapeHtml(downloadName || 'de-blancas-jewelry-concept.jpg')}"
          aria-label="Download generated concept image"
        >
          <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
            <path d="M12 4v10m0 0 4-4m-4 4-4-4M5 19h14" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"></path>
          </svg>
          <span>Download</span>
        </a>
      `
      : '';
    return `
      <div class="pearl-designer__generated-media">
        <div class="pearl-designer__generated-aura" aria-hidden="true"></div>
        <div class="pearl-designer__generated-veil" aria-hidden="true"></div>
        <img class="pearl-designer__generated-image" src="${escapeHtml(src)}" alt="${escapeHtml(alt)}"${buildImageAttributeString(options)}>
        ${downloadMarkup}
      </div>
    `;
  }

  function buildImageAttributeString(options = {}) {
    const loading = String(options?.loading || 'lazy').trim() || 'lazy';
    const decoding = String(options?.decoding || 'async').trim() || 'async';
    const fetchPriority = String(options?.fetchPriority || '').trim();
    const fallbackSrc = String(options?.fallbackSrc || '').trim();
    const width = Number(options?.width || 0);
    const height = Number(options?.height || 0);

    return [
      ` loading="${escapeHtml(loading)}"`,
      ` decoding="${escapeHtml(decoding)}"`,
      fetchPriority ? ` fetchpriority="${escapeHtml(fetchPriority)}"` : '',
      width > 0 ? ` width="${escapeHtml(String(width))}"` : '',
      height > 0 ? ` height="${escapeHtml(String(height))}"` : '',
      fallbackSrc ? ` data-fallback-src="${escapeHtml(fallbackSrc)}"` : '',
      fallbackSrc
        ? ' onerror="if(this.dataset.fallbackSrc&&!this.dataset.fallbackApplied){this.dataset.fallbackApplied=\'true\';this.src=this.dataset.fallbackSrc;}"'
        : '',
    ].join('');
  }

  function buildHistoryImageFallbackSrc(item, historyImageEndpoint, variant) {
    const normalizedVariant = variant === 'full' ? 'full' : 'thumb';
    return `${historyImageEndpoint}/${encodeURIComponent(String(item?.id || ''))}?variant=${normalizedVariant}`;
  }

  function buildHistoryImageDownloadSrc(item, historyImageEndpoint) {
    const generationId = String(item?.id || '').trim();
    if (!generationId) {
      return '';
    }
    return `${historyImageEndpoint}/${encodeURIComponent(generationId)}?variant=full&download=1`;
  }

  function buildGeneratedImageDownloadName(input = {}) {
    const jewelrySlug = slugifyDownloadSegment(input.jewelryType) || 'jewelry';
    const dateSegment = compactDateSegment(input.createdAt) || compactDateSegment(new Date().toISOString());
    const idSegment = slugifyDownloadSegment(input.generationId) || 'concept';
    const extension = mimeTypeToDownloadExtension(input.mimeType);
    return `de-blancas-${jewelrySlug}-concept-${dateSegment}-${idSegment}.${extension}`;
  }

  function mimeTypeToDownloadExtension(mimeType) {
    const normalized = String(mimeType || '').toLowerCase();
    if (normalized.includes('jpeg') || normalized.includes('jpg')) {
      return 'jpg';
    }
    if (normalized.includes('webp')) {
      return 'webp';
    }
    if (normalized.includes('png')) {
      return 'png';
    }
    return 'jpg';
  }

  function compactDateSegment(value) {
    const normalized = String(value || '').trim();
    const match = normalized.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (match) {
      return `${match[1]}${match[2]}${match[3]}`;
    }

    const date = new Date(normalized);
    if (Number.isNaN(date.getTime())) {
      return '';
    }

    return [
      date.getUTCFullYear(),
      String(date.getUTCMonth() + 1).padStart(2, '0'),
      String(date.getUTCDate()).padStart(2, '0'),
    ].join('');
  }

  function slugifyDownloadSegment(value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .replace(/&/g, ' and ')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .slice(0, 72);
  }

  function getHistoryThumbnailSrc(item, historyImageEndpoint) {
    const thumbnailCandidates = [
      item?.thumbnailUrl,
      item?.thumbnailURL,
      item?.thumbnail_url,
      item?.thumbUrl,
      item?.thumbURL,
      item?.thumb_url,
      item?.historyThumbnailUrl,
      item?.history_thumbnail_url,
      item?.r2ThumbnailUrl,
      item?.r2_thumbnail_url,
    ];

    const thumbnailSrc = firstNonEmptyString(thumbnailCandidates);
    if (thumbnailSrc) {
      return thumbnailSrc;
    }

    return `${historyImageEndpoint}/${encodeURIComponent(String(item?.id || ''))}?variant=thumb`;
  }

  function getHistoryFullImageSrc(item, historyImageEndpoint) {
    const fullSizeCandidates = [
      item?.fullResolutionImageUrl,
      item?.fullResolutionURL,
      item?.full_resolution_image_url,
      item?.fullImageUrl,
      item?.full_image_url,
      item?.r2FullImageUrl,
      item?.r2_full_image_url,
      item?.r2ImageUrl,
      item?.r2_image_url,
      item?.normalizedImageUrl,
      item?.normalized_image_url,
      item?.imageUrl,
      item?.imageURL,
      item?.image_url,
    ];

    const fullSizeSrc = firstNonEmptyString(
      fullSizeCandidates.filter((value) => !isLikelyThumbnailSrc(value))
    );
    if (fullSizeSrc) {
      return fullSizeSrc;
    }

    return `${historyImageEndpoint}/${encodeURIComponent(String(item?.id || ''))}?variant=full`;
  }

  function isLikelyThumbnailSrc(value) {
    const normalized = String(value || '').trim().toLowerCase();
    if (!normalized) {
      return false;
    }

    return (
      normalized.includes('variant=thumb') ||
      normalized.includes('thumbnail') ||
      normalized.includes('thumb_') ||
      normalized.includes('/thumb/') ||
      normalized.includes('_thumb.')
    );
  }

  function firstNonEmptyString(values) {
    if (!Array.isArray(values)) {
      return '';
    }

    for (const value of values) {
      const normalized = String(value || '').trim();
      if (normalized) {
        return normalized;
      }
    }

    return '';
  }

  function renderNotesMarkup(copy) {
    return escapeHtml(String(copy || '')).replace(/\n+/g, '<br>');
  }

  function placeholderMarkup(title, copy) {
    return `<div class="pearl-designer__placeholder"><div><strong>${escapeHtml(title)}</strong>${escapeHtml(copy)}</div></div>`;
  }

  function historySkeletonMarkup(count) {
    const cardCount = Math.max(1, Number(count || 0) || 0);
    const cards = Array.from({ length: cardCount }, () => `
      <div class="pearl-designer__appointment-thumb pearl-designer__appointment-thumb--skeleton" aria-hidden="true">
        <div class="pearl-designer__appointment-thumb-media pearl-designer__appointment-thumb-media--skeleton">
          <span class="pearl-designer__appointment-thumb-skeleton-block pearl-designer__appointment-thumb-skeleton-block--media"></span>
        </div>
        <span class="pearl-designer__appointment-thumb-copy pearl-designer__appointment-thumb-copy--skeleton">
          <span class="pearl-designer__appointment-thumb-skeleton-block pearl-designer__appointment-thumb-skeleton-block--title"></span>
          <span class="pearl-designer__appointment-thumb-skeleton-block pearl-designer__appointment-thumb-skeleton-block--meta"></span>
        </span>
      </div>
    `).join('');

    return `<div class="pearl-designer__appointment-gallery-skeleton" aria-label="Loading recent concepts">${cards}</div>`;
  }

  function buildHistorySessionCacheKey(shopDomain, customerId, customerEmail) {
    const parts = [
      'pearl-designer-history',
      String(shopDomain || '').trim() || 'shop',
      String(customerId || '').trim() || String(customerEmail || '').trim() || 'guest',
    ];

    return parts.join(':');
  }

  function readHistorySessionCache(cacheKey) {
    if (!cacheKey || typeof window === 'undefined' || !window.sessionStorage) {
      return [];
    }

    try {
      const raw = window.sessionStorage.getItem(cacheKey);
      if (!raw) {
        return [];
      }

      const parsed = JSON.parse(raw);
      return Array.isArray(parsed?.generations) ? parsed.generations : [];
    } catch (error) {
      return [];
    }
  }

  function writeHistorySessionCache(cacheKey, generations) {
    if (!cacheKey || typeof window === 'undefined' || !window.sessionStorage) {
      return;
    }

    try {
      window.sessionStorage.setItem(
        cacheKey,
        JSON.stringify({
          generations: Array.isArray(generations) ? generations : [],
          updatedAt: Date.now(),
        })
      );
    } catch (error) {
      return;
    }
  }

  function ensureImageDeliveryConnectionHints(origin) {
    const normalizedOrigin = String(origin || '').trim();
    if (!normalizedOrigin || typeof document === 'undefined' || !document.head) {
      return;
    }

    const dnsHref = normalizedOrigin.replace(/^https?:/, '');
    const hints = [
      { rel: 'dns-prefetch', href: dnsHref },
      { rel: 'preconnect', href: normalizedOrigin, crossOrigin: 'anonymous' },
    ];

    hints.forEach((hint) => {
      const hintKey = `${hint.rel}:${hint.href}`;
      if (document.head.querySelector(`link[data-pearl-hint="${hintKey}"]`)) {
        return;
      }

      const link = document.createElement('link');
      link.rel = hint.rel;
      link.href = hint.href;
      link.dataset.pearlHint = hintKey;
      if (hint.crossOrigin) {
        link.crossOrigin = hint.crossOrigin;
      }
      document.head.appendChild(link);
    });
  }

  function scheduleIdleTask(callback) {
    if (typeof callback !== 'function') {
      return;
    }

    if (typeof window !== 'undefined' && typeof window.requestIdleCallback === 'function') {
      window.requestIdleCallback(() => callback(), { timeout: 1200 });
      return;
    }

    window.setTimeout(callback, 180);
  }

  function renderingMarkup(messages) {
    const items = Array.isArray(messages) && messages.length ? messages : ['Rendering in progress'];
    const timeline = items
      .map(
        (message, index) =>
          `<span class="pearl-designer__rendering-message" style="--message-index:${index};--message-count:${items.length};">${escapeHtml(message)}</span>`
      )
      .join('');

    return `
      <div class="pearl-designer__rendering">
        <div class="pearl-designer__rendering-halo"></div>
        <div class="pearl-designer__rendering-core"></div>
        <div class="pearl-designer__rendering-copy">
          ${timeline}
        </div>
      </div>
    `;
  }

  function trackDesignerEvent(eventName, properties) {
    if (!eventName) {
      return;
    }

    const dataLayer = window.dataLayer;
    if (dataLayer && typeof dataLayer.push === 'function') {
      dataLayer.push({
        event: eventName,
        ...properties,
      });
    }

    sendDesignerAnalyticsEvent(eventName, properties);
  }

  function getAnalyticsEndpoint() {
    if (window.__pearlDesignerAnalyticsEndpoint) {
      return window.__pearlDesignerAnalyticsEndpoint;
    }

    const firstSection = sections[0];
    return joinPath(firstSection?.dataset.apiEndpoint || '/apps/ai-pearl-designer', 'analytics');
  }

  function sendDesignerAnalyticsEvent(eventName, properties) {
    const endpoint = getAnalyticsEndpoint();
    if (!endpoint) {
      return;
    }

    const payload = JSON.stringify({
      eventName,
      properties: properties || {},
    });

    try {
      if (navigator.sendBeacon) {
        const blob = new Blob([payload], { type: 'application/json' });
        if (navigator.sendBeacon(endpoint, blob)) {
          return;
        }
      }
    } catch (error) {
      // Fall through to fetch when beacon is blocked.
    }

    fetch(endpoint, {
      method: 'POST',
      credentials: 'same-origin',
      keepalive: true,
      headers: {
        'Content-Type': 'application/json',
      },
      body: payload,
    }).catch(() => {});
  }

  function hasAdvancedGuestSelections(formData) {
    if (!(formData instanceof FormData)) {
      return false;
    }

    return (
      String(formData.get('pearl_type') || 'freshwater') !== 'freshwater' ||
      Number(formData.get('pearl_size_mm') || 8) !== 8 ||
      String(formData.get('metal_material') || 'gold_vermeil') !== 'gold_vermeil' ||
      String(formData.get('diamond_quality') || 'imitation_diamond') !== 'imitation_diamond' ||
      Number(formData.get('complexity_setting') || 2) !== 2 ||
      formData.get('expedite_production') === 'on'
    );
  }

  function getOpeningIntroAssetsEndpoint() {
    const firstSection = sections[0];
    return joinPath(firstSection?.dataset.apiEndpoint || '/apps/ai-pearl-designer', 'intro-assets');
  }

  function primeOpeningIntroAssets(forceRefresh) {
    if (!forceRefresh && window.__pearlDesignerIntroAssetsPromise) {
      return window.__pearlDesignerIntroAssetsPromise;
    }

    const endpoint = getOpeningIntroAssetsEndpoint();
    window.__pearlDesignerIntroAssetsPromise = fetch(endpoint, {
      method: 'GET',
      credentials: 'same-origin',
    })
      .then(async (response) => {
        const payload = await parseApiResponse(response);
        if (!response.ok || payload.ok === false) {
          throw new Error(payload.error || 'Unable to load opening intro assets.');
        }

        return normalizeOpeningIntroAssets(payload.items);
      })
      .catch(() => [])
      .then((items) => {
        window.__pearlDesignerIntroAssets = items;
        const activeOverlay =
          document.body.querySelector('.pearl-designer-intro-overlay') ||
          document.querySelector('[data-role="intro-overlay-shell"]');

        if (activeOverlay?.isConnected) {
          hydrateOpeningIntroAssets(activeOverlay, items);
        }

        return items;
      });

    return window.__pearlDesignerIntroAssetsPromise;
  }

  function normalizeOpeningIntroAssets(items) {
    if (!Array.isArray(items)) {
      return [];
    }

    return items
      .map((item, index) => ({
        id: item?.id || index + 1,
        imageUrl: String(item?.imageUrl || item?.image_url || '').trim(),
        alt: String(item?.alt || `Opening intro frame ${index + 1}`).trim(),
      }))
      .filter((item) => item.imageUrl);
  }

  function createOpeningIntroMarkup() {
    return `
      <div class="pearl-designer-intro-overlay__glow pearl-designer-intro-overlay__glow--a" aria-hidden="true"></div>
      <div class="pearl-designer-intro-overlay__glow pearl-designer-intro-overlay__glow--b" aria-hidden="true"></div>
      <div class="pearl-designer-intro-overlay__ring" aria-hidden="true"></div>
      <div class="pearl-designer-intro-overlay__mosaic-wrap" aria-hidden="true">
        <div class="pearl-designer-intro-overlay__mosaic-halo pearl-designer-intro-overlay__mosaic-halo--a"></div>
        <div class="pearl-designer-intro-overlay__mosaic-halo pearl-designer-intro-overlay__mosaic-halo--b"></div>
        <div class="pearl-designer-intro-overlay__mosaic-glass"></div>
        <div class="pearl-designer-intro-overlay__mosaic" data-role="intro-mosaic"></div>
      </div>
      <div class="pearl-designer-intro-overlay__copy">
        <div class="pearl-designer-intro-overlay__logo" aria-hidden="true">
          <img
            src="https://cdn.shopify.com/s/files/1/0714/5439/2561/files/De_Blancas_Logo_Transparent.png?v=1774029747"
            alt="DE BLANCAS"
            loading="eager"
            decoding="async"
          >
        </div>
        <p class="pearl-designer-intro-overlay__eyebrow">AI Pearl Atelier</p>
        <h1 class="pearl-designer-intro-overlay__title">
          <span class="pearl-designer-intro-overlay__brand">DE BLANCAS</span>
          <span class="pearl-designer-intro-overlay__separator">x</span>
          <span class="pearl-designer-intro-overlay__gemini">Google Gemini</span>
        </h1>
        <p class="pearl-designer-intro-overlay__subtitle">Light, craft, and imagination are coming together.</p>
      </div>
    `;
  }

  function hydrateOpeningIntroAssets(overlay, items) {
    const mosaic = overlay.querySelector('[data-role="intro-mosaic"]');
    if (!mosaic) {
      return;
    }

    const markup = buildOpeningIntroMosaicMarkup(items);
    mosaic.innerHTML = markup;
    overlay.classList.toggle('has-intro-assets', Boolean(markup));
  }

  function buildOpeningIntroMosaicMarkup(items) {
    const layout = getOpeningIntroLayout();
    if (!Array.isArray(items) || !items.length) {
      return '';
    }

    return `
      <div
        class="pearl-designer-intro-overlay__mosaic-flow"
        style="--intro-column-count:${layout.columns.length};"
      >
        ${layout.columns
          .map((column, columnIndex) =>
            buildOpeningIntroWaterfallColumn(items, layout, column, columnIndex)
          )
          .join('')}
      </div>
    `;
  }

  function getOpeningIntroLayout() {
    if (window.innerWidth <= 768) {
      return {
        columns: OPENING_INTRO_COLUMNS_MOBILE,
        itemsPerColumn: 10,
      };
    }

    return {
      columns: OPENING_INTRO_COLUMNS_DESKTOP,
      itemsPerColumn: 11,
    };
  }

  function buildOpeningIntroWaterfallColumn(items, layout, column, columnIndex) {
    const frames = getOpeningIntroColumnFrames(
      items,
      columnIndex,
      layout.itemsPerColumn,
      layout.columns.length
    );

    return `
      <div
        class="pearl-designer-intro-overlay__mosaic-column"
        style="--intro-column-delay:${column.delay};--intro-column-duration:${column.duration};--intro-column-start:${column.start};--intro-column-end:${column.end};"
      >
        <div class="pearl-designer-intro-overlay__mosaic-column-track">
          ${frames
            .map((item, itemIndex) => {
              const variant =
                OPENING_INTRO_CARD_VARIANTS[
                  (columnIndex * layout.itemsPerColumn + itemIndex) %
                    OPENING_INTRO_CARD_VARIANTS.length
                ];
              return `
                <figure
                  class="pearl-designer-intro-overlay__mosaic-card"
                  style="--intro-card-delay:${(itemIndex * 0.08).toFixed(2)}s;--intro-card-rotate:${variant.rotate};--intro-card-shift:${variant.shift};--intro-card-scale:${variant.scale};"
                >
                  <div class="pearl-designer-intro-overlay__mosaic-card-shell">
                    <img
                      src="${escapeHtml(item.imageUrl)}"
                      alt="${escapeHtml(item.alt || `Opening intro frame ${itemIndex + 1}`)}"
                      decoding="async"
                    >
                  </div>
                </figure>
              `;
            })
            .join('')}
        </div>
      </div>
    `;
  }

  function getOpeningIntroColumnFrames(items, columnIndex, itemsPerColumn, columnCount) {
    const frames = [];

    for (let itemIndex = 0; itemIndex < itemsPerColumn; itemIndex += 1) {
      const source = items[(columnIndex + itemIndex * columnCount) % items.length];
      frames.push({
        id: source.id,
        imageUrl: source.imageUrl,
        alt: source.alt,
      });
    }

    return frames;
  }

  function playOpeningIntro() {
    const now = Date.now();

    if (window.__pearlDesignerIntroActive) {
      return;
    }

    if (
      window.__pearlDesignerIntroLastPlayedAt &&
      now - window.__pearlDesignerIntroLastPlayedAt < OPENING_INTRO_REPLAY_GUARD_MS
    ) {
      return;
    }

    window.__pearlDesignerIntroActive = true;
    window.__pearlDesignerIntroLastPlayedAt = now;

    let overlay = document.querySelector('[data-role="intro-overlay-shell"]');
    const existingBodyOverlay = document.body.querySelector('.pearl-designer-intro-overlay');

    if (!overlay && existingBodyOverlay) {
      overlay = existingBodyOverlay;
    }

    if (!overlay) {
      overlay = document.createElement('div');
    }

    overlay.className = 'pearl-designer-intro-overlay';
    overlay.setAttribute('data-role', 'intro-overlay-shell');
    overlay.setAttribute('aria-hidden', 'true');
    overlay.innerHTML = createOpeningIntroMarkup();
    hydrateOpeningIntroAssets(
      overlay,
      Array.isArray(window.__pearlDesignerIntroAssets) ? window.__pearlDesignerIntroAssets : []
    );

    if (overlay.parentNode !== document.body) {
      document.body.appendChild(overlay);
    }
    document.body.classList.add('pearl-designer-intro-active');
    setOpeningIntroFocusPoint(overlay);
    primeOpeningIntroAssets();

    overlay.classList.remove('is-leaving');
    overlay.style.animation = 'none';
    void overlay.offsetHeight;
    overlay.style.animation = '';

    window.clearTimeout(window.__pearlDesignerIntroHideTimer);
    window.clearTimeout(window.__pearlDesignerIntroRemoveTimer);

    window.__pearlDesignerIntroHideTimer = window.setTimeout(() => {
      overlay.classList.add('is-leaving');
    }, OPENING_INTRO_HIDE_MS);

    window.__pearlDesignerIntroRemoveTimer = window.setTimeout(() => {
      overlay.remove();
      window.__pearlDesignerIntroActive = false;
      document.body.classList.remove('pearl-designer-intro-active');
    }, OPENING_INTRO_TOTAL_MS);
  }

  function releaseOpeningIntroScrollLock() {
    document.body.classList.remove('pearl-designer-intro-active');

    const overlay = document.querySelector('[data-role="intro-overlay-shell"]');
    if (overlay?.classList.contains('is-leaving')) {
      overlay.remove();
    }

    if (window.__pearlDesignerIntroActive && !document.querySelector('[data-role="intro-overlay-shell"]')) {
      window.__pearlDesignerIntroActive = false;
    }
  }

  function setOpeningIntroFocusPoint(overlay) {
    if (!overlay) {
      return;
    }

    const focusTarget = overlay.querySelector('.pearl-designer-intro-overlay__separator');
    if (!focusTarget) {
      overlay.style.setProperty('--intro-focus-x', '50%');
      overlay.style.setProperty('--intro-focus-y', '36%');
      return;
    }

    const rect = focusTarget.getBoundingClientRect();
    const centerX = rect.left + rect.width / 2;
    const centerY = rect.top + rect.height / 2;
    const xPercent = Math.min(Math.max((centerX / window.innerWidth) * 100, 0), 100);
    const yPercent = Math.min(Math.max((centerY / window.innerHeight) * 100, 0), 100);

    overlay.style.setProperty('--intro-focus-x', `${xPercent}%`);
    overlay.style.setProperty('--intro-focus-y', `${yPercent}%`);
  }

  function setStatus(node, message, state) {
    if (!node) {
      return;
    }

    node.textContent = message;
    node.dataset.state = state;
  }

  function fileToDataUrl(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(String(reader.result || ''));
      reader.onerror = () => reject(new Error('Image upload failed to read. Please try another file.'));
      reader.readAsDataURL(file);
    });
  }

  async function prepareUploadImage(file) {
    const originalDataUrl = await fileToDataUrl(file);
    const image = await loadImageElement(originalDataUrl);
    const targetSize = fitWithinBounds(image.naturalWidth, image.naturalHeight, UPLOAD_IMAGE_MAX_DIMENSION);
    const shouldResize =
      targetSize.width !== image.naturalWidth || targetSize.height !== image.naturalHeight;
    const shouldReencode =
      shouldResize || file.size > UPLOAD_IMAGE_PASSTHROUGH_BYTES || !/^image\/jpeg$/i.test(file.type || '');

    if (!shouldReencode) {
      return {
        file,
        dataUrl: originalDataUrl,
        mimeType: file.type || 'image/jpeg',
        byteSize: file.size,
      };
    }

    const canvas = document.createElement('canvas');
    canvas.width = targetSize.width;
    canvas.height = targetSize.height;
    const context = canvas.getContext('2d');
    if (!context) {
      throw new Error('This browser could not prepare the uploaded image.');
    }

    context.fillStyle = '#ffffff';
    context.fillRect(0, 0, canvas.width, canvas.height);
    context.drawImage(image, 0, 0, canvas.width, canvas.height);

    const optimizedDataUrl = canvas.toDataURL('image/jpeg', UPLOAD_IMAGE_OUTPUT_QUALITY);
    return {
      file,
      dataUrl: optimizedDataUrl,
      mimeType: 'image/jpeg',
      byteSize: dataUrlByteSize(optimizedDataUrl),
    };
  }

  async function prepareUploadImageWithFallback(file) {
    try {
      return await (preparedUploadPromise || prepareUploadImage(file));
    } catch (error) {
      const originalDataUrl = await fileToDataUrl(file);
      return {
        file,
        dataUrl: originalDataUrl,
        mimeType: file.type || 'image/jpeg',
        byteSize: file.size,
      };
    }
  }

  async function createHistoryThumbnailDataUrl(sourceDataUrl) {
    const image = await loadImageElement(sourceDataUrl);
    const targetSize = fitWithinBounds(
      image.naturalWidth,
      image.naturalHeight,
      HISTORY_THUMB_MAX_DIMENSION
    );
    const canvas = document.createElement('canvas');
    canvas.width = targetSize.width;
    canvas.height = targetSize.height;
    const context = canvas.getContext('2d');
    if (!context) {
      throw new Error('This browser could not prepare the history thumbnail.');
    }

    context.fillStyle = '#ffffff';
    context.fillRect(0, 0, canvas.width, canvas.height);
    context.drawImage(image, 0, 0, canvas.width, canvas.height);

    return {
      dataUrl: canvas.toDataURL('image/jpeg', HISTORY_THUMB_OUTPUT_QUALITY),
      mimeType: 'image/jpeg',
    };
  }

  async function normalizeGeneratedOutputDataUrl(sourceDataUrl) {
    const image = await loadImageElement(sourceDataUrl);
    const canvas = document.createElement('canvas');
    canvas.width = GENERATED_IMAGE_TARGET_WIDTH;
    canvas.height = GENERATED_IMAGE_TARGET_HEIGHT;
    const context = canvas.getContext('2d');
    if (!context) {
      throw new Error('This browser could not normalize the generated image.');
    }

    context.fillStyle = '#ffffff';
    context.fillRect(0, 0, canvas.width, canvas.height);

    const coverSize = fitCoverBounds(
      image.naturalWidth,
      image.naturalHeight,
      canvas.width,
      canvas.height
    );

    context.drawImage(
      image,
      coverSize.x,
      coverSize.y,
      coverSize.width,
      coverSize.height
    );

    return {
      dataUrl: canvas.toDataURL('image/jpeg', GENERATED_IMAGE_OUTPUT_QUALITY),
      mimeType: 'image/jpeg',
    };
  }

  function loadImageElement(dataUrl) {
    return new Promise((resolve, reject) => {
      const image = new Image();
      image.onload = () => resolve(image);
      image.onerror = () => reject(new Error('The uploaded image could not be processed. Please try another file.'));
      image.src = dataUrl;
    });
  }

  function fitWithinBounds(width, height, maxDimension) {
    const safeWidth = Math.max(1, Number(width || 1));
    const safeHeight = Math.max(1, Number(height || 1));
    const longestSide = Math.max(safeWidth, safeHeight);
    if (longestSide <= maxDimension) {
      return {
        width: safeWidth,
        height: safeHeight,
      };
    }

    const scale = maxDimension / longestSide;
    return {
      width: Math.max(1, Math.round(safeWidth * scale)),
      height: Math.max(1, Math.round(safeHeight * scale)),
    };
  }

  function fitCoverBounds(width, height, targetWidth, targetHeight) {
    const safeWidth = Math.max(1, Number(width || 1));
    const safeHeight = Math.max(1, Number(height || 1));
    const scale = Math.max(targetWidth / safeWidth, targetHeight / safeHeight);
    const drawWidth = Math.round(safeWidth * scale);
    const drawHeight = Math.round(safeHeight * scale);

    return {
      width: drawWidth,
      height: drawHeight,
      x: Math.round((targetWidth - drawWidth) / 2),
      y: Math.round((targetHeight - drawHeight) / 2),
    };
  }

  function dataUrlByteSize(dataUrl) {
    const base64 = String(dataUrl || '').split(',')[1] || '';
    if (!base64) {
      return 0;
    }

    const padding = (base64.match(/=*$/) || [''])[0].length;
    return Math.max(0, Math.floor((base64.length * 3) / 4) - padding);
  }

  function formatBytes(bytes) {
    const value = Number(bytes || 0);
    if (value < 1024) {
      return `${value} B`;
    }
    if (value < 1024 * 1024) {
      return `${(value / 1024).toFixed(0)} KB`;
    }
    return `${(value / 1024 / 1024).toFixed(2)} MB`;
  }

  function sameFile(left, right) {
    if (!left || !right) {
      return false;
    }

    return (
      left.name === right.name &&
      left.size === right.size &&
      left.lastModified === right.lastModified
    );
  }

  function formatBreakdownAmount(value, formatter) {
    return Number(value || 0) === 0 ? 'Free' : formatter.format(value);
  }

  function formatHistoryMoneyRange(estimate, fallbackCurrency) {
    const normalizedEstimate = normalizeEstimatePayload(estimate, fallbackCurrency);
    if (!normalizedEstimate) {
      return 'Estimate unavailable';
    }

    const formatter = new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: normalizedEstimate.currency || fallbackCurrency || 'USD',
      maximumFractionDigits: 0,
    });

    return `${formatter.format(Number(normalizedEstimate.minimum || 0))} - ${formatter.format(Number(normalizedEstimate.maximum || 0))}`;
  }

  function normalizeEstimatePayload(source, fallbackCurrency) {
    if (!source || typeof source !== 'object') {
      return null;
    }

    const nestedEstimateCandidates = [
      source.estimate,
      source.result?.estimate,
      source.payload?.estimate,
      source.data?.estimate,
      source.response?.estimate,
      source.history?.estimate,
      source.generation?.estimate,
    ].filter((candidate) => candidate && typeof candidate === 'object');

    const baseEstimate = nestedEstimateCandidates[0] || source;

    const breakdownSourceCandidates = [
      baseEstimate.breakdown,
      baseEstimate.breakdownRows,
      baseEstimate.breakdown_rows,
      baseEstimate.breakdownJson,
      baseEstimate.breakdown_json,
      baseEstimate.estimateBreakdown,
      baseEstimate.estimateBreakdownJson,
      baseEstimate.estimate_breakdown,
      baseEstimate.estimate_breakdown_json,
      baseEstimate.priceBreakdown,
      baseEstimate.price_breakdown,
      baseEstimate.costBreakdown,
      baseEstimate.cost_breakdown,
      source.breakdown,
      source.breakdownRows,
      source.breakdown_rows,
      source.breakdownJson,
      source.breakdown_json,
      source.estimateBreakdown,
      source.estimateBreakdownJson,
      source.estimate_breakdown,
      source.estimate_breakdown_json,
      source.priceBreakdown,
      source.price_breakdown,
      source.costBreakdown,
      source.cost_breakdown,
      source.estimateBreakdownRows,
      source.estimate_breakdown_rows,
    ];

    const breakdownSource = breakdownSourceCandidates.find((candidate) =>
      hasEstimateBreakdownContent(candidate)
    );

    const normalizedBreakdown = normalizeEstimateBreakdownRows(breakdownSource);

    const minimum = Number(
      baseEstimate.minimum ??
        baseEstimate.min ??
        baseEstimate.low ??
        baseEstimate.lower ??
        baseEstimate.estimateMinimum ??
        baseEstimate.estimate_minimum ??
        source.minimum ??
        source.min ??
        source.low ??
        source.lower ??
        source.estimateMinimum ??
        source.estimate_minimum ??
        0
    );

    const maximum = Number(
      baseEstimate.maximum ??
        baseEstimate.max ??
        baseEstimate.high ??
        baseEstimate.upper ??
        baseEstimate.estimateMaximum ??
        baseEstimate.estimate_maximum ??
        source.maximum ??
        source.max ??
        source.high ??
        source.upper ??
        source.estimateMaximum ??
        source.estimate_maximum ??
        minimum
    );

    const summary = String(
      baseEstimate.summary ??
        baseEstimate.estimateSummary ??
        baseEstimate.estimate_summary ??
        baseEstimate.description ??
        baseEstimate.copy ??
        source.summary ??
        source.estimateSummary ??
        source.estimate_summary ??
        source.description ??
        source.copy ??
        ''
    ).trim();

    const leadTimeDays = String(
      baseEstimate.leadTimeDays ??
        baseEstimate.estimateLeadTimeDays ??
        baseEstimate.estimate_lead_time_days ??
        baseEstimate.lead_time_days ??
        baseEstimate.leadTime ??
        baseEstimate.lead_time ??
        source.leadTimeDays ??
        source.estimateLeadTimeDays ??
        source.estimate_lead_time_days ??
        source.lead_time_days ??
        source.leadTime ??
        source.lead_time ??
        '10-18'
    ).trim();

    if (!normalizedBreakdown.length && !Number.isFinite(minimum) && !Number.isFinite(maximum)) {
      return null;
    }

    return {
      currency: String(
        baseEstimate.currency ??
          baseEstimate.currencyCode ??
          baseEstimate.currency_code ??
          source.currency ??
          source.currencyCode ??
          source.currency_code ??
          fallbackCurrency ??
          'USD'
      ).trim(),
      minimum: Number.isFinite(minimum) ? minimum : 0,
      maximum: Number.isFinite(maximum) ? maximum : Number.isFinite(minimum) ? minimum : 0,
      summary,
      leadTimeDays,
      breakdown: normalizedBreakdown,
    };
  }

  function normalizeEstimateBreakdownRows(source) {
    if (typeof source === 'string') {
      const parsed = parseStructuredValue(source);
      if (parsed && parsed !== source) {
        return normalizeEstimateBreakdownRows(parsed);
      }
      return [];
    }

    if (Array.isArray(source)) {
      return source
        .map((item) => ({
          label: String(item?.label || item?.name || item?.title || '').trim(),
          amount: Number(item?.amount ?? item?.value ?? item?.price ?? 0),
        }))
        .filter((item) => item.label);
    }

    if (!source || typeof source !== 'object') {
      return [];
    }

    const labelMap = {
      metalcost: 'Metal Cost',
      pearlcost: 'Pearl Cost',
      gemstonecost: 'Gemstone Cost',
      craftsmanproduction: 'Craftsman&production',
      craftsmanandproduction: 'Craftsman&production',
      craftsmanshipproduction: 'Craftsman&production',
      craftsmanshipandproduction: 'Craftsman&production',
      productioncost: 'Craftsman&production',
      laborcost: 'Craftsman&production',
      labourcost: 'Craftsman&production',
      makingcost: 'Craftsman&production',
      settingcost: 'Gemstone Cost',
      diamondcost: 'Gemstone Cost',
      gemstoneandsettingcost: 'Gemstone Cost',
    };

    return Object.entries(source)
      .map(([key, value]) => {
        const normalizedKey = String(key || '')
          .replace(/[^a-zA-Z0-9]/g, '')
          .toLowerCase();
        const amount =
          typeof value === 'object' && value !== null
            ? Number(value.amount ?? value.value ?? value.price ?? 0)
            : Number(value ?? 0);

        const explicitLabel =
          typeof value === 'object' && value !== null
            ? String(value.label || value.name || value.title || '').trim()
            : '';

        return {
          label: explicitLabel || labelMap[normalizedKey] || humanizeBreakdownKey(key),
          amount,
        };
      })
      .filter((item) => item.label && Number.isFinite(item.amount));
  }

  function hasEstimateBreakdownContent(candidate) {
    if (!candidate) {
      return false;
    }

    if (Array.isArray(candidate)) {
      return candidate.length > 0;
    }

    if (typeof candidate === 'string') {
      return Boolean(parseStructuredValue(candidate));
    }

    return typeof candidate === 'object';
  }

  function parseStructuredValue(value) {
    const source = String(value || '').trim();
    if (!source) {
      return null;
    }

    try {
      return JSON.parse(source);
    } catch (error) {
      return null;
    }
  }

  function humanizeBreakdownKey(value) {
    const source = String(value || '').trim();
    if (!source) {
      return '';
    }

    return source
      .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
      .replace(/[_-]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim()
      .replace(/\b\w/g, (character) => character.toUpperCase());
  }

  function humanizeLabel(value) {
    const labels = {
      ring: 'Ring',
      necklace: 'Necklace',
      earrings: 'Earrings',
      bracelet: 'Bracelet',
      pendant: 'Pendant',
      brooch: 'Brooch',
      freshwater: 'Freshwater Pearl',
      akoya: 'Akoya Pearl',
      tahitian: 'Tahitian Pearl',
      south_sea: 'South Sea Pearl',
      mabe: 'Mabe Pearl',
      silver: 'Silver',
      gold_vermeil: 'Gold Vermeil',
      gold_14k_yellow: '14K Yellow Gold',
      gold_14k_white: '14K White Gold',
      gold_18k_yellow: '18K Yellow Gold',
      gold_18k_white: '18K White Gold',
      gold_18k_rose: '18K Rose Gold',
      imitation_diamond: 'Imitation Diamond',
      labgrown_diamond: 'Lab-Grown Diamond',
      natural_diamond: 'Natural Diamond',
    };

    if (labels[value]) {
      return labels[value];
    }

    return String(value || '')
      .split('_')
      .filter(Boolean)
      .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
      .join(' ');
  }

  function detectTimezone() {
    try {
      return Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';
    } catch (error) {
      return 'UTC';
    }
  }

  async function parseApiResponse(response) {
    const contentType = response.headers.get('content-type') || '';
    const bodyText = await response.text();

    if (contentType.includes('application/json')) {
      try {
        return JSON.parse(bodyText);
      } catch (error) {
        throw new Error('The API returned malformed JSON.');
      }
    }

    const compactText = bodyText.replace(/\s+/g, ' ').trim();
    const htmlTitleMatch = compactText.match(/<title>(.*?)<\/title>/i);
    const htmlBodyHintMatch = compactText.match(/<body[^>]*>(.*?)<\/body>/i);
    const htmlHint = htmlTitleMatch?.[1] || htmlBodyHintMatch?.[1] || compactText;
    const cleanedHint = stripHtml(htmlHint).slice(0, 180);

    if (!response.ok) {
      return {
        error: cleanedHint || `The API returned a non-JSON error page (HTTP ${response.status}).`,
      };
    }

    throw new Error('The API returned non-JSON content. Please check the App Proxy or Worker logs.');
  }

  function getGuestTrialStorageKey(shopDomain) {
    return `pearl-designer-guest-trial:${String(shopDomain || 'default').trim().toLowerCase()}`;
  }

  function getVisitorIdStorageKey(shopDomain) {
    return `${getGuestTrialStorageKey(shopDomain)}:visitor`;
  }

  function getVisitorId(shopDomain) {
    const key = getVisitorIdStorageKey(shopDomain);
    try {
      const existing = window.localStorage.getItem(key);
      if (existing) {
        return existing;
      }

      const created =
        window.crypto && typeof window.crypto.randomUUID === 'function'
          ? window.crypto.randomUUID()
          : `visitor-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
      window.localStorage.setItem(key, created);
      return created;
    } catch (error) {
      return `visitor-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
    }
  }

  function getStoredGuestSessionId(shopDomain) {
    const key = `${getGuestTrialStorageKey(shopDomain)}:session`;
    try {
      return window.localStorage.getItem(key) || '';
    } catch (error) {
      return '';
    }
  }

  function buildStorefrontLoginUrl(baseUrl) {
    const fallback = String(baseUrl || '/account/login').trim() || '/account/login';
    const returnPath = `${window.location.pathname}${window.location.search}${window.location.hash}`;

    try {
      const url = new URL(fallback, window.location.origin);
      if (returnPath && !url.searchParams.has('return_url')) {
        url.searchParams.set('return_url', returnPath);
      }

      return url.origin === window.location.origin
        ? `${url.pathname}${url.search}${url.hash}`
        : url.toString();
    } catch (error) {
      const separator = fallback.includes('?') ? '&' : '?';
      return returnPath && !/[?&]return_url=/.test(fallback)
        ? `${fallback}${separator}return_url=${encodeURIComponent(returnPath)}`
        : fallback;
    }
  }

  function ensureTurnstileApi() {
    if (window.turnstile && typeof window.turnstile.render === 'function') {
      return Promise.resolve(window.turnstile);
    }

    if (window.__pearlDesignerTurnstilePromise) {
      return window.__pearlDesignerTurnstilePromise;
    }

    window.__pearlDesignerTurnstilePromise = new Promise((resolve, reject) => {
      const existingScript = document.querySelector('script[data-pearl-turnstile]');
      if (existingScript) {
        existingScript.addEventListener('load', () => resolve(window.turnstile), { once: true });
        existingScript.addEventListener('error', () => reject(new Error('Turnstile failed to load.')), {
          once: true,
        });
        return;
      }

      const script = document.createElement('script');
      script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
      script.async = true;
      script.defer = true;
      script.dataset.pearlTurnstile = 'true';
      script.onload = () => resolve(window.turnstile);
      script.onerror = () => reject(new Error('Turnstile failed to load.'));
      document.head.appendChild(script);
    });

    return window.__pearlDesignerTurnstilePromise;
  }

  function getGuestSessionId(shopDomain) {
    const key = `${getGuestTrialStorageKey(shopDomain)}:session`;
    try {
      const existing = getStoredGuestSessionId(shopDomain);
      if (existing) {
        return existing;
      }

      const created =
        window.crypto && typeof window.crypto.randomUUID === 'function'
          ? window.crypto.randomUUID()
          : `guest-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
      window.localStorage.setItem(key, created);
      return created;
    } catch (error) {
      return `guest-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
    }
  }

  function getInfluencerTrackingContext() {
    try {
      const url = new URL(window.location.href);
      const code = String(url.searchParams.get('ref') || url.searchParams.get('creator') || '')
        .trim()
        .toLowerCase();
      if (!code) {
        return {
          code: '',
          campaignHandle: '',
          utmSource: '',
          utmMedium: '',
          utmCampaign: '',
          utmTerm: '',
          utmContent: '',
        };
      }

      return {
        code,
        campaignHandle: String(url.searchParams.get('campaign') || '').trim().toLowerCase(),
        utmSource: String(url.searchParams.get('utm_source') || '').trim(),
        utmMedium: String(url.searchParams.get('utm_medium') || '').trim(),
        utmCampaign: String(url.searchParams.get('utm_campaign') || '').trim(),
        utmTerm: String(url.searchParams.get('utm_term') || '').trim(),
        utmContent: String(url.searchParams.get('utm_content') || '').trim(),
      };
    } catch (error) {
      return {
        code: '',
        campaignHandle: '',
        utmSource: '',
        utmMedium: '',
        utmCampaign: '',
        utmTerm: '',
        utmContent: '',
      };
    }
  }

  function persistInfluencerAttribution(options = {}) {
    const endpoint = String(options.endpoint || '').trim();
    const tracking = options.tracking || {};
    const influencerCode = String(tracking.code || '').trim().toLowerCase();
    if (!endpoint || !influencerCode || typeof fetch !== 'function') {
      return;
    }

    const shopDomain = String(options.shopDomain || '').trim().toLowerCase();
    const visitorId = String(options.visitorId || '').trim();
    const dedupeKey = [
      'pearl-designer-attribution',
      shopDomain || 'default',
      influencerCode,
      visitorId || 'anonymous',
    ].join(':');

    try {
      if (window.sessionStorage.getItem(dedupeKey) === 'sent') {
        return;
      }
      window.sessionStorage.setItem(dedupeKey, 'sent');
    } catch (error) {
      // Continue without client-side dedupe if storage is unavailable.
    }

    const payload = {
      influencerCode,
      campaignHandle: String(tracking.campaignHandle || '').trim().toLowerCase(),
      utmSource: String(tracking.utmSource || '').trim(),
      utmMedium: String(tracking.utmMedium || '').trim(),
      utmCampaign: String(tracking.utmCampaign || '').trim(),
      utmTerm: String(tracking.utmTerm || '').trim(),
      utmContent: String(tracking.utmContent || '').trim(),
      visitorId,
      guestSessionId: String(options.guestSessionId || '').trim(),
      customerId: String(options.customerId || '').trim(),
      customerEmail: String(options.customerEmail || '').trim(),
      shopDomain,
      landingPage: `${window.location.pathname}${window.location.search}`,
      referrer: String(document.referrer || '').trim(),
    };

    fetch(endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
      keepalive: true,
      credentials: 'same-origin',
    }).catch(() => {
      try {
        window.sessionStorage.removeItem(dedupeKey);
      } catch (error) {
        return;
      }
    });
  }

  function hasGuestTrialBeenUsed(shopDomain) {
    try {
      return window.localStorage.getItem(getGuestTrialStorageKey(shopDomain)) === 'used';
    } catch (error) {
      return false;
    }
  }

  function markGuestTrialUsed(shopDomain) {
    try {
      window.localStorage.setItem(getGuestTrialStorageKey(shopDomain), 'used');
    } catch (error) {
      return;
    }
  }

  function joinPath(base, suffix) {
    const trimmedBase = String(base || '').replace(/\/+$/, '');
    return `${trimmedBase}/${suffix}`;
  }

  function normalizeAppointmentBaseUrl(url) {
    const value = String(url || '').trim();
    if (!value) {
      return '/pages/appointment-booking';
    }

    return value.replace(
      /\/pages\/designer-appointment-booking(?=$|[?#])/,
      '/pages/appointment-booking'
    );
  }

  function stripHtml(value) {
    return String(value).replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim();
  }

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }
})();
